// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const MasonryIdByName = {
  Brick_03_L_Acme_Abbeville: 1249,
  Brick_03_L_Acme_AdenBlend: 1242,
  Brick_03_L_Acme_AdobeWells: 399,
  Brick_03_L_Acme_AnsleyPark: 1123,
  Brick_03_L_Acme_ArcticMist: 1382,
  Brick_03_L_Acme_AuburnHills: 1298,
  Brick_03_L_Acme_Augusta: 400,
  Brick_03_L_Acme_Brookstone: 401,
  Brick_03_L_Acme_Callisburg: 843,
  Brick_03_L_Acme_CameronHills: 815,
  Brick_03_L_Acme_CasaBlanca: 759,
  Brick_03_L_Acme_CiboloTrail: 1781,
  Brick_03_L_Acme_CopperasCove: 1782,
  Brick_03_L_Acme_DentonAntique: 816,
  Brick_03_L_Acme_ForestHills: 537,
  Brick_03_L_Acme_FrenchChateaux: 585,
  Brick_03_L_Acme_Frostwood: 402,
  Brick_03_L_Acme_GlacierBay: 403,
  Brick_03_L_Acme_GlacierWhite: 1410,
  Brick_03_L_Acme_HamptonMill: 404,
  Brick_03_L_Acme_Highstone: 405,
  Brick_03_L_Acme_Inverness: 1383,
  Brick_03_L_Acme_Menawa: 1124,
  Brick_03_L_Acme_MochaBrownAntique: 586,
  Brick_03_L_Acme_MountainBrook: 406,
  Brick_03_L_Acme_MushroomBrown: 1125,
  Brick_03_L_Acme_OldFrancisco: 817,
  Brick_03_L_Acme_OldTavern: 1186,
  Brick_03_L_Acme_OxfordPlace: 1783,
  Brick_03_L_Acme_OysterBay: 407,
  Brick_03_L_Acme_ParkShadows: 408,
  Brick_03_L_Acme_PineRidge: 409,
  Brick_03_L_Acme_RapidFalls: 410,
  Brick_03_L_Acme_Redmont: 1718,
  Brick_03_L_Acme_Rockwell: 411,
  Brick_03_L_Acme_Saltgrass: 1305,
  Brick_03_L_Acme_SanJose: 538,
  Brick_03_L_Acme_Scottsdale: 412,
  Brick_03_L_Acme_Seabrook: 539,
  Brick_03_L_Acme_Shenandoah: 1347,
  Brick_03_L_Acme_Silvercreek: 760,
  Brick_03_L_Acme_Silverthorn: 413,
  Brick_03_L_Acme_SpanishBay: 1348,
  Brick_03_L_Acme_SpanishFort: 1719,
  Brick_03_L_Acme_StoneBay: 414,
  Brick_03_L_Acme_StoneLake: 1697,
  Brick_03_L_Acme_SummerSage: 1306,
  Brick_03_L_Acme_Texas: 1126,
  Brick_03_L_Acme_WhiteBirch: 1844,
  Brick_03_L_Acme_WhiteBluff: 1349,
  Brick_03_L_Acme_WhiteRiverRock: 415,
  Brick_03_L_Acme_Winterstone: 818,
  Brick_03_L_Belden_BlackDiamondVelour: 1411,
  Brick_03_L_Belden_GraphiteVelour: 1412,
  Brick_03_L_Bilco_Camel: 990,
  Brick_03_L_Bilco_Everest: 761,
  Brick_03_L_Bilco_GrayMist: 762,
  Brick_03_L_Bilco_Graystone: 991,
  Brick_03_L_Bilco_Onyx: 992,
  Brick_03_L_Bilco_Phoenix: 993,
  Brick_03_L_Bilco_Scottsdale: 763,
  Brick_03_L_Bilco_Stardust: 416,
  Brick_03_L_Binsa_AmericanAntique: 587,
  Brick_03_L_Binsa_EnglishDove: 1207,
  Brick_03_L_Binsa_HillStone: 588,
  Brick_03_L_Binsa_Monroe: 1571,
  Brick_03_L_Binsa_Smokey: 1572,
  Brick_03_L_CasaDaSassi_CdS_FullBrown: 103,
  Brick_03_L_Cherokee_Augusta: 1,
  Brick_03_L_Cherokee_Magnolia: 1235,
  Brick_03_L_Cherokee_Natchez: 2,
  Brick_03_L_Claymex_Alpine: 892,
  Brick_03_L_Claymex_Aspen: 1208,
  Brick_03_L_Claymex_Brownfield: 899,
  Brick_03_L_Claymex_Cobblestone: 906,
  Brick_03_L_Claymex_Keystone: 913,
  Brick_03_L_Claymex_LeMont: 348,
  Brick_03_L_Claymex_Onyx: 920,
  Brick_03_L_Claymex_Oxford: 349,
  Brick_03_L_Claymex_Pewter: 927,
  Brick_03_L_Claymex_UrbanaAntique: 1784,
  Brick_03_L_Claymex_Woodcreek: 934,
  Brick_03_L_Claymex_York: 941,
  Brick_03_L_Columbus_Charleston: 1720,
  Brick_03_L_Columbus_Georgetown: 1721,
  Brick_03_L_Columbus_MagnoliaBay: 1557,
  Brick_03_L_Columbus_OldBailey: 1722,
  Brick_03_L_Columbus_Ortega: 1723,
  Brick_03_L_Columbus_StoneChase: 1724,
  Brick_03_L_Columbus_Weracoba2: 1558,
  Brick_03_L_CommercialBrickCompany_CBC_ChandlerWhite: 1307,
  Brick_03_L_CommercialBrickCompany_CBC_CommercialAntique: 1785,
  Brick_03_L_CommercialBrickCompany_CBC_Hollister: 1308,
  Brick_03_L_FAKE_Chalk: 3,
  Brick_03_L_GeneralShale_GS_AlpineSelect: 621,
  Brick_03_L_GeneralShale_GS_Ashview: 378,
  Brick_03_L_GeneralShale_GS_BarnsleyTudor: 561,
  Brick_03_L_GeneralShale_GS_BourbonTrail: 318,
  Brick_03_L_GeneralShale_GS_BradfordHall: 1067,
  Brick_03_L_GeneralShale_GS_CapersIsland: 871,
  Brick_03_L_GeneralShale_GS_CavalryGray: 319,
  Brick_03_L_GeneralShale_GS_ClaytonFalls: 1088,
  Brick_03_L_GeneralShale_GS_ColonyPointe: 1683,
  Brick_03_L_GeneralShale_GS_Cortez: 1053,
  Brick_03_L_GeneralShale_GS_CumberlandTudor: 1684,
  Brick_03_L_GeneralShale_GS_Domino: 312,
  Brick_03_L_GeneralShale_GS_EnglishPub: 1620,
  Brick_03_L_GeneralShale_GS_Graymoor: 1074,
  Brick_03_L_GeneralShale_GS_Graysburg: 1438,
  Brick_03_L_GeneralShale_GS_HeritageTrail: 885,
  Brick_03_L_GeneralShale_GS_Ironworks: 1621,
  Brick_03_L_GeneralShale_GS_KeenelandElite: 562,
  Brick_03_L_GeneralShale_GS_ManorHouseTudor: 563,
  Brick_03_L_GeneralShale_GS_ModenaPaver: 1459,
  Brick_03_L_GeneralShale_GS_MorningSmoke: 1439,
  Brick_03_L_GeneralShale_GS_NewcastleGray: 639,
  Brick_03_L_GeneralShale_GS_NolinRiver: 320,
  Brick_03_L_GeneralShale_GS_OldEdisto: 645,
  Brick_03_L_GeneralShale_GS_OldEnglishTutor: 1440,
  Brick_03_L_GeneralShale_GS_Peppermill: 1622,
  Brick_03_L_GeneralShale_GS_RedColonial: 1095,
  Brick_03_L_GeneralShale_GS_ShadowGrey: 564,
  Brick_03_L_GeneralShale_GS_SpanishMoss: 850,
  Brick_03_L_GeneralShale_GS_StoneMountain: 872,
  Brick_03_L_GeneralShale_GS_SwanCreek: 336,
  Brick_03_L_GeneralShale_GS_Valor: 1116,
  Brick_03_L_GeneralShale_GS_VintagePort: 622,
  Brick_03_L_GeneralShale_GS_Winstar: 379,
  Brick_03_L_GeneralShale_GS_Winterhaven: 1466,
  Brick_03_L_GeneralShale_GS_Wynnewood: 623,
  Brick_03_L_GlenGery_Americano: 1623,
  Brick_03_L_GlenGery_AnthraciteSmooth: 1624,
  Brick_03_L_GlenGery_AntiqueWhite: 417,
  Brick_03_L_GlenGery_AspenWhite: 1625,
  Brick_03_L_GlenGery_AztecWhite: 418,
  Brick_03_L_GlenGery_BaxterBrownSmooth: 1626,
  Brick_03_L_GlenGery_Birch: 419,
  Brick_03_L_GlenGery_Casablanca: 420,
  Brick_03_L_GlenGery_ClassicCreamSmooth: 1627,
  Brick_03_L_GlenGery_RusticGrayWaterstruck: 1628,
  Brick_03_L_GlenGery_WilliamsburgBradford: 421,
  Brick_03_L_GlenGery_WilliamsburgCherryCreek: 422,
  Brick_03_L_GlenGery_WilliamsburgHampton: 423,
  Brick_03_L_Harristone_Charleston: 969,
  Brick_03_L_Harristone_DoveGrey: 970,
  Brick_03_L_Harristone_Midnight: 1536,
  Brick_03_L_Harristone_WhiteSand: 971,
  Brick_03_L_HenryBrick_HB_Avondale: 1537,
  Brick_03_L_HenryBrick_HB_CypressPoint: 337,
  Brick_03_L_Heritage_Ashwood: 1046,
  Brick_03_L_Lusco_PearlRiver: 424,
  Brick_03_L_Master_Chateau: 1786,
  Brick_03_L_Master_PortEdwards: 1787,
  Brick_03_L_Meridian_Alamo: 4,
  Brick_03_L_Meridian_AlpineSelect: 5,
  Brick_03_L_Meridian_Baytown: 6,
  Brick_03_L_Meridian_Belhaven: 7,
  Brick_03_L_Meridian_ChimneyMountain: 255,
  Brick_03_L_Meridian_Dover: 8,
  Brick_03_L_Meridian_FireOak: 1573,
  Brick_03_L_Meridian_Laredo: 9,
  Brick_03_L_Meridian_MtRushmore: 10,
  Brick_03_L_Meridian_NorthHighland: 11,
  Brick_03_L_Meridian_OldGuignard: 12,
  Brick_03_L_Meridian_OldJackson: 13,
  Brick_03_L_Meridian_PortHuron: 256,
  Brick_03_L_Meridian_SaltPlains: 14,
  Brick_03_L_Meridian_ShadowFalls: 15,
  Brick_03_L_Meridian_Smithsonian: 16,
  Brick_03_L_Meridian_StAndrews: 17,
  Brick_03_L_Meridian_StLorain: 18,
  Brick_03_L_Meridian_SummerAsh: 19,
  Brick_03_L_Meridian_WhiteHillstone: 1574,
  Brick_03_L_Meridian_WhiteRiverRock: 1575,
  Brick_03_L_Paint_SW_SW_6246_NorthStar: 143,
  Brick_03_L_Paint_SW_SW_7004_Snowbound: 303,
  Brick_03_L_Paint_SW_SW_7068_GrizzleGray: 20,
  Brick_03_L_Paint_SW_SW_9171_FeltedWool: 144,
  Brick_03_L_Paint_SW_SW_9174_MothWing: 145,
  Brick_03_L_PGH_Bark: 948,
  Brick_03_L_PGH_CharacterPutty: 949,
  Brick_03_L_PGH_CharacterRedRock: 950,
  Brick_03_L_PrestigeStone_PS_Farmhouse: 1256,
  Brick_03_L_ProVia_Boston: 1018,
  Brick_03_L_ProVia_Cobblestone: 1019,
  Brick_03_L_ProVia_Delaware: 1020,
  Brick_03_L_ProVia_Midnight: 1021,
  Brick_03_L_PVStone_Colonial: 1193,
  Brick_03_L_PVStone_Neptune: 1194,
  Brick_03_L_RedRiver_AlpineFog: 425,
  Brick_03_L_RedRiver_Amarylis: 426,
  Brick_03_L_RedRiver_BurlingtonAntique: 427,
  Brick_03_L_RedRiver_Caprock: 428,
  Brick_03_L_RedRiver_CrescentGrove: 429,
  Brick_03_L_RedRiver_CypressSprings: 430,
  Brick_03_L_RedRiver_FireOak: 431,
  Brick_03_L_RedRiver_FlintRanch: 1309,
  Brick_03_L_RedRiver_FoggyMorning: 764,
  Brick_03_L_RedRiver_Glenwood: 432,
  Brick_03_L_RedRiver_GlisteningSprings: 589,
  Brick_03_L_RedRiver_Madrono: 1698,
  Brick_03_L_RedRiver_Mayfield: 433,
  Brick_03_L_RedRiver_OzarkSmoke: 1310,
  Brick_03_L_RedRiver_Ridgemont: 434,
  Brick_03_L_RedRiver_SaltPlains: 435,
  Brick_03_L_RedRiver_ShadowFalls: 436,
  Brick_03_L_RedRiver_ShelteredBluff: 437,
  Brick_03_L_RedRiver_Silverado: 438,
  Brick_03_L_RedRiver_SnowMist: 765,
  Brick_03_L_RedRiver_SteelManor: 1788,
  Brick_03_L_RedRiver_SummerAsh: 1789,
  Brick_03_L_RedRiver_Tecomate: 439,
  Brick_03_L_RedRiver_WellsValley: 440,
  Brick_03_L_RedRiver_WhiteRiverRock: 766,
  Brick_03_L_Ryder_AntiqueWhite: 1350,
  Brick_03_L_Ryder_Casablanca: 1351,
  Brick_03_L_Spaulding_Onslow: 1538,
  Brick_03_L_Spaulding_YankeeHill: 1413,
  Brick_03_L_TexasStone_DarkGrayLuxbrick: 1396,
  Brick_03_L_TexasStone_OldTownLux: 1397,
  Brick_03_L_Triangle_BessemerGray: 21,
  Brick_03_L_Triangle_CapeFear: 1081,
  Brick_03_L_Triangle_ChesapeakeGrey: 1179,
  Brick_03_L_Triangle_DoverWhite: 372,
  Brick_03_L_Triangle_EvelynBay: 22,
  Brick_03_L_Triangle_FederalHill: 1151,
  Brick_03_L_Triangle_FortMill: 851,
  Brick_03_L_Triangle_JeffersonPark: 350,
  Brick_03_L_Triangle_KnobHill: 1725,
  Brick_03_L_Triangle_LibbyMill: 852,
  Brick_03_L_Triangle_MountainBranchSelect: 23,
  Brick_03_L_Triangle_Nantucket: 1102,
  Brick_03_L_Triangle_Northampton: 104,
  Brick_03_L_Triangle_Oakton: 1221,
  Brick_03_L_Triangle_OldColony: 105,
  Brick_03_L_Triangle_Oxford: 24,
  Brick_03_L_Triangle_Porter: 590,
  Brick_03_L_Triangle_Portsmouth: 1152,
  Brick_03_L_Triangle_RiverStreet: 1153,
  Brick_03_L_Triangle_SeelyTown: 351,
  Brick_03_L_Triangle_ShadowRidge: 1613,
  Brick_03_L_Triangle_SouthHampton: 25,
  Brick_03_L_Triangle_Wilmington: 1154,
  Brick_03_L_USBrick_Alamo: 1467,
  Brick_03_L_USBrick_AspenChase: 1468,
  Brick_03_L_USBrick_Belhaven: 1469,
  Brick_03_L_USBrick_BelleMeade: 1470,
  Brick_03_L_USBrick_Blackberry: 555,
  Brick_03_L_USBrick_Laredo: 1726,
  Brick_03_L_USBrick_Magnolia: 1257,
  Brick_03_L_USBrick_Monaco: 1060,
  Brick_03_L_USBrick_MtRushmore: 1471,
  Brick_03_L_USBrick_NatchezTrace: 1258,
  Brick_03_L_USBrick_Newcastle: 1472,
  Brick_03_L_USBrick_NorthHighland: 1473,
  Brick_03_L_USBrick_OldJackson: 1109,
  Brick_03_L_USBrick_OldOverton: 1474,
  Brick_03_L_USBrick_OldWaverly: 1222,
  Brick_03_L_USBrick_OysterCove: 1259,
  Brick_03_L_USBrick_ShadowStone: 1260,
  Brick_03_L_USBrick_StLorain: 1475,
  Brick_03_L_USBrick_TimberWood: 1261,
  Brick_03_L_USBrick_Twilight: 1606,
  Brick_03_L_USBrick_WeatheredWhite: 1699,
  Brick_05_L_Acme_Abbeville: 1250,
  Brick_05_L_Acme_AdenBlend: 1243,
  Brick_05_L_Acme_AdobeWells: 441,
  Brick_05_L_Acme_AnsleyPark: 1127,
  Brick_05_L_Acme_ArcticMist: 1384,
  Brick_05_L_Acme_AuburnHills: 1299,
  Brick_05_L_Acme_Augusta: 442,
  Brick_05_L_Acme_Brookstone: 443,
  Brick_05_L_Acme_Callisburg: 844,
  Brick_05_L_Acme_CameronHills: 819,
  Brick_05_L_Acme_CasaBlanca: 767,
  Brick_05_L_Acme_CiboloTrail: 1790,
  Brick_05_L_Acme_CopperasCove: 1791,
  Brick_05_L_Acme_DentonAntique: 820,
  Brick_05_L_Acme_ForestHills: 540,
  Brick_05_L_Acme_FrenchChateaux: 591,
  Brick_05_L_Acme_Frostwood: 444,
  Brick_05_L_Acme_GlacierBay: 445,
  Brick_05_L_Acme_GlacierWhite: 1414,
  Brick_05_L_Acme_HamptonMill: 446,
  Brick_05_L_Acme_Highstone: 447,
  Brick_05_L_Acme_Inverness: 1385,
  Brick_05_L_Acme_Menawa: 1128,
  Brick_05_L_Acme_MochaBrownAntique: 592,
  Brick_05_L_Acme_MountainBrook: 448,
  Brick_05_L_Acme_MushroomBrown: 1129,
  Brick_05_L_Acme_OldFrancisco: 821,
  Brick_05_L_Acme_OldTavern: 1187,
  Brick_05_L_Acme_OxfordPlace: 1792,
  Brick_05_L_Acme_OysterBay: 449,
  Brick_05_L_Acme_ParkShadows: 450,
  Brick_05_L_Acme_PineRidge: 451,
  Brick_05_L_Acme_RapidFalls: 452,
  Brick_05_L_Acme_Redmont: 1727,
  Brick_05_L_Acme_Rockwell: 453,
  Brick_05_L_Acme_Saltgrass: 1311,
  Brick_05_L_Acme_SanJose: 541,
  Brick_05_L_Acme_Scottsdale: 454,
  Brick_05_L_Acme_Seabrook: 542,
  Brick_05_L_Acme_Shenandoah: 1352,
  Brick_05_L_Acme_Silvercreek: 768,
  Brick_05_L_Acme_Silverthorn: 455,
  Brick_05_L_Acme_SpanishBay: 1353,
  Brick_05_L_Acme_SpanishFort: 1728,
  Brick_05_L_Acme_StoneBay: 456,
  Brick_05_L_Acme_StoneLake: 1700,
  Brick_05_L_Acme_SummerSage: 1312,
  Brick_05_L_Acme_Texas: 1130,
  Brick_05_L_Acme_WhiteBirch: 1845,
  Brick_05_L_Acme_WhiteBluff: 1354,
  Brick_05_L_Acme_WhiteRiverRock: 457,
  Brick_05_L_Acme_Winterstone: 822,
  Brick_05_L_Belden_BlackDiamondVelour: 1415,
  Brick_05_L_Belden_GraphiteVelour: 1416,
  Brick_05_L_Bilco_Camel: 994,
  Brick_05_L_Bilco_Everest: 769,
  Brick_05_L_Bilco_GrayMist: 770,
  Brick_05_L_Bilco_Graystone: 995,
  Brick_05_L_Bilco_Onyx: 996,
  Brick_05_L_Bilco_Phoenix: 997,
  Brick_05_L_Bilco_Scottsdale: 771,
  Brick_05_L_Bilco_Stardust: 458,
  Brick_05_L_Binsa_AmericanAntique: 593,
  Brick_05_L_Binsa_EnglishDove: 1209,
  Brick_05_L_Binsa_HillStone: 594,
  Brick_05_L_Binsa_Monroe: 1576,
  Brick_05_L_Binsa_Smokey: 1577,
  Brick_05_L_CasaDaSassi_CdS_FullBrown: 106,
  Brick_05_L_Cherokee_Augusta: 26,
  Brick_05_L_Cherokee_Magnolia: 1236,
  Brick_05_L_Cherokee_Natchez: 27,
  Brick_05_L_Claymex_Alpine: 893,
  Brick_05_L_Claymex_Aspen: 1210,
  Brick_05_L_Claymex_Brownfield: 900,
  Brick_05_L_Claymex_Cobblestone: 907,
  Brick_05_L_Claymex_Keystone: 914,
  Brick_05_L_Claymex_LeMont: 352,
  Brick_05_L_Claymex_Onyx: 921,
  Brick_05_L_Claymex_Oxford: 353,
  Brick_05_L_Claymex_Pewter: 928,
  Brick_05_L_Claymex_UrbanaAntique: 1793,
  Brick_05_L_Claymex_Woodcreek: 935,
  Brick_05_L_Claymex_York: 942,
  Brick_05_L_Columbus_Charleston: 1729,
  Brick_05_L_Columbus_Georgetown: 1730,
  Brick_05_L_Columbus_MagnoliaBay: 1559,
  Brick_05_L_Columbus_OldBailey: 1731,
  Brick_05_L_Columbus_Ortega: 1732,
  Brick_05_L_Columbus_StoneChase: 1733,
  Brick_05_L_Columbus_Weracoba2: 1560,
  Brick_05_L_CommercialBrickCompany_CBC_ChandlerWhite: 1313,
  Brick_05_L_CommercialBrickCompany_CBC_CommercialAntique: 1794,
  Brick_05_L_CommercialBrickCompany_CBC_Hollister: 1314,
  Brick_05_L_FAKE_Chalk: 28,
  Brick_05_L_GeneralShale_GS_AlpineSelect: 624,
  Brick_05_L_GeneralShale_GS_Ashview: 380,
  Brick_05_L_GeneralShale_GS_BarnsleyTudor: 565,
  Brick_05_L_GeneralShale_GS_BourbonTrail: 321,
  Brick_05_L_GeneralShale_GS_BradfordHall: 1068,
  Brick_05_L_GeneralShale_GS_CapersIsland: 873,
  Brick_05_L_GeneralShale_GS_CavalryGray: 322,
  Brick_05_L_GeneralShale_GS_ClaytonFalls: 1089,
  Brick_05_L_GeneralShale_GS_ColonyPointe: 1685,
  Brick_05_L_GeneralShale_GS_Cortez: 1054,
  Brick_05_L_GeneralShale_GS_CumberlandTudor: 1686,
  Brick_05_L_GeneralShale_GS_Domino: 313,
  Brick_05_L_GeneralShale_GS_EnglishPub: 1629,
  Brick_05_L_GeneralShale_GS_Graymoor: 1075,
  Brick_05_L_GeneralShale_GS_Graysburg: 1441,
  Brick_05_L_GeneralShale_GS_HeritageTrail: 886,
  Brick_05_L_GeneralShale_GS_Ironworks: 1630,
  Brick_05_L_GeneralShale_GS_KeenelandElite: 566,
  Brick_05_L_GeneralShale_GS_ManorHouseTudor: 567,
  Brick_05_L_GeneralShale_GS_ModenaPaver: 1460,
  Brick_05_L_GeneralShale_GS_MorningSmoke: 1442,
  Brick_05_L_GeneralShale_GS_NewcastleGray: 640,
  Brick_05_L_GeneralShale_GS_NolinRiver: 323,
  Brick_05_L_GeneralShale_GS_OldEdisto: 646,
  Brick_05_L_GeneralShale_GS_OldEnglishTutor: 1443,
  Brick_05_L_GeneralShale_GS_Peppermill: 1631,
  Brick_05_L_GeneralShale_GS_RedColonial: 1096,
  Brick_05_L_GeneralShale_GS_ShadowGrey: 568,
  Brick_05_L_GeneralShale_GS_SpanishMoss: 853,
  Brick_05_L_GeneralShale_GS_StoneMountain: 874,
  Brick_05_L_GeneralShale_GS_SwanCreek: 338,
  Brick_05_L_GeneralShale_GS_Valor: 1117,
  Brick_05_L_GeneralShale_GS_VintagePort: 625,
  Brick_05_L_GeneralShale_GS_Winstar: 381,
  Brick_05_L_GeneralShale_GS_Winterhaven: 1476,
  Brick_05_L_GeneralShale_GS_Wynnewood: 626,
  Brick_05_L_GlenGery_Americano: 1632,
  Brick_05_L_GlenGery_AnthraciteSmooth: 1633,
  Brick_05_L_GlenGery_AntiqueWhite: 459,
  Brick_05_L_GlenGery_AspenWhite: 1634,
  Brick_05_L_GlenGery_AztecWhite: 460,
  Brick_05_L_GlenGery_BaxterBrownSmooth: 1635,
  Brick_05_L_GlenGery_Birch: 461,
  Brick_05_L_GlenGery_Casablanca: 462,
  Brick_05_L_GlenGery_ClassicCreamSmooth: 1636,
  Brick_05_L_GlenGery_RusticGrayWaterstruck: 1637,
  Brick_05_L_GlenGery_WilliamsburgBradford: 463,
  Brick_05_L_GlenGery_WilliamsburgCherryCreek: 464,
  Brick_05_L_GlenGery_WilliamsburgHampton: 465,
  Brick_05_L_Harristone_Charleston: 972,
  Brick_05_L_Harristone_DoveGrey: 973,
  Brick_05_L_Harristone_Midnight: 1539,
  Brick_05_L_Harristone_WhiteSand: 974,
  Brick_05_L_HenryBrick_HB_Avondale: 1540,
  Brick_05_L_HenryBrick_HB_CypressPoint: 339,
  Brick_05_L_Heritage_Ashwood: 1047,
  Brick_05_L_Lusco_PearlRiver: 466,
  Brick_05_L_Master_Chateau: 1795,
  Brick_05_L_Master_PortEdwards: 1796,
  Brick_05_L_Meridian_Alamo: 29,
  Brick_05_L_Meridian_AlpineSelect: 30,
  Brick_05_L_Meridian_Baytown: 31,
  Brick_05_L_Meridian_Belhaven: 32,
  Brick_05_L_Meridian_ChimneyMountain: 257,
  Brick_05_L_Meridian_Dover: 33,
  Brick_05_L_Meridian_FireOak: 1578,
  Brick_05_L_Meridian_Laredo: 34,
  Brick_05_L_Meridian_MtRushmore: 35,
  Brick_05_L_Meridian_NorthHighland: 36,
  Brick_05_L_Meridian_OldGuignard: 37,
  Brick_05_L_Meridian_OldJackson: 38,
  Brick_05_L_Meridian_PortHuron: 258,
  Brick_05_L_Meridian_SaltPlains: 39,
  Brick_05_L_Meridian_ShadowFalls: 40,
  Brick_05_L_Meridian_Smithsonian: 41,
  Brick_05_L_Meridian_StAndrews: 42,
  Brick_05_L_Meridian_StLorain: 43,
  Brick_05_L_Meridian_SummerAsh: 44,
  Brick_05_L_Meridian_WhiteHillstone: 1579,
  Brick_05_L_Meridian_WhiteRiverRock: 1580,
  Brick_05_L_Paint_SW_SW_6246_NorthStar: 146,
  Brick_05_L_Paint_SW_SW_7004_Snowbound: 304,
  Brick_05_L_Paint_SW_SW_7068_GrizzleGray: 45,
  Brick_05_L_Paint_SW_SW_9171_FeltedWool: 147,
  Brick_05_L_Paint_SW_SW_9174_MothWing: 148,
  Brick_05_L_PGH_Bark: 951,
  Brick_05_L_PGH_CharacterPutty: 952,
  Brick_05_L_PGH_CharacterRedRock: 953,
  Brick_05_L_PrestigeStone_PS_Farmhouse: 1262,
  Brick_05_L_ProVia_Boston: 1022,
  Brick_05_L_ProVia_Cobblestone: 1023,
  Brick_05_L_ProVia_Delaware: 1024,
  Brick_05_L_ProVia_Midnight: 1025,
  Brick_05_L_PVStone_Colonial: 1195,
  Brick_05_L_PVStone_Neptune: 1196,
  Brick_05_L_RedRiver_AlpineFog: 467,
  Brick_05_L_RedRiver_Amarylis: 468,
  Brick_05_L_RedRiver_BurlingtonAntique: 469,
  Brick_05_L_RedRiver_Caprock: 470,
  Brick_05_L_RedRiver_CrescentGrove: 471,
  Brick_05_L_RedRiver_CypressSprings: 472,
  Brick_05_L_RedRiver_FireOak: 473,
  Brick_05_L_RedRiver_FlintRanch: 1315,
  Brick_05_L_RedRiver_FoggyMorning: 772,
  Brick_05_L_RedRiver_Glenwood: 474,
  Brick_05_L_RedRiver_GlisteningSprings: 595,
  Brick_05_L_RedRiver_Madrono: 1701,
  Brick_05_L_RedRiver_Mayfield: 475,
  Brick_05_L_RedRiver_OzarkSmoke: 1316,
  Brick_05_L_RedRiver_Ridgemont: 476,
  Brick_05_L_RedRiver_SaltPlains: 477,
  Brick_05_L_RedRiver_ShadowFalls: 478,
  Brick_05_L_RedRiver_ShelteredBluff: 479,
  Brick_05_L_RedRiver_Silverado: 480,
  Brick_05_L_RedRiver_SnowMist: 773,
  Brick_05_L_RedRiver_SteelManor: 1797,
  Brick_05_L_RedRiver_SummerAsh: 1798,
  Brick_05_L_RedRiver_Tecomate: 481,
  Brick_05_L_RedRiver_WellsValley: 482,
  Brick_05_L_RedRiver_WhiteRiverRock: 774,
  Brick_05_L_Ryder_AntiqueWhite: 1355,
  Brick_05_L_Ryder_Casablanca: 1356,
  Brick_05_L_Spaulding_Onslow: 1541,
  Brick_05_L_Spaulding_YankeeHill: 1417,
  Brick_05_L_TexasStone_DarkGrayLuxbrick: 1398,
  Brick_05_L_TexasStone_OldTownLux: 1399,
  Brick_05_L_Triangle_BessemerGray: 46,
  Brick_05_L_Triangle_CapeFear: 1082,
  Brick_05_L_Triangle_ChesapeakeGrey: 1180,
  Brick_05_L_Triangle_DoverWhite: 373,
  Brick_05_L_Triangle_EvelynBay: 47,
  Brick_05_L_Triangle_FederalHill: 1155,
  Brick_05_L_Triangle_FortMill: 854,
  Brick_05_L_Triangle_JeffersonPark: 354,
  Brick_05_L_Triangle_KnobHill: 1734,
  Brick_05_L_Triangle_LibbyMill: 855,
  Brick_05_L_Triangle_MountainBranchSelect: 48,
  Brick_05_L_Triangle_Nantucket: 1103,
  Brick_05_L_Triangle_Northampton: 107,
  Brick_05_L_Triangle_Oakton: 1223,
  Brick_05_L_Triangle_OldColony: 108,
  Brick_05_L_Triangle_Oxford: 49,
  Brick_05_L_Triangle_Porter: 596,
  Brick_05_L_Triangle_Portsmouth: 1156,
  Brick_05_L_Triangle_RiverStreet: 1157,
  Brick_05_L_Triangle_SeelyTown: 355,
  Brick_05_L_Triangle_ShadowRidge: 1614,
  Brick_05_L_Triangle_SouthHampton: 50,
  Brick_05_L_Triangle_Wilmington: 1158,
  Brick_05_L_USBrick_Alamo: 1477,
  Brick_05_L_USBrick_AspenChase: 1478,
  Brick_05_L_USBrick_Belhaven: 1479,
  Brick_05_L_USBrick_BelleMeade: 1480,
  Brick_05_L_USBrick_Blackberry: 556,
  Brick_05_L_USBrick_Laredo: 1735,
  Brick_05_L_USBrick_Magnolia: 1263,
  Brick_05_L_USBrick_Monaco: 1061,
  Brick_05_L_USBrick_MtRushmore: 1481,
  Brick_05_L_USBrick_NatchezTrace: 1264,
  Brick_05_L_USBrick_Newcastle: 1482,
  Brick_05_L_USBrick_NorthHighland: 1483,
  Brick_05_L_USBrick_OldJackson: 1110,
  Brick_05_L_USBrick_OldOverton: 1484,
  Brick_05_L_USBrick_OldWaverly: 1224,
  Brick_05_L_USBrick_OysterCove: 1265,
  Brick_05_L_USBrick_ShadowStone: 1266,
  Brick_05_L_USBrick_StLorain: 1485,
  Brick_05_L_USBrick_TimberWood: 1267,
  Brick_05_L_USBrick_Twilight: 1607,
  Brick_05_L_USBrick_WeatheredWhite: 1702,
  Brick_075_Default: 51,
  Brick_075_L_Acme_Abbeville: 1251,
  Brick_075_L_Acme_AdenBlend: 1244,
  Brick_075_L_Acme_AdobeWells: 483,
  Brick_075_L_Acme_AnsleyPark: 1131,
  Brick_075_L_Acme_ArcticMist: 1386,
  Brick_075_L_Acme_AuburnHills: 1300,
  Brick_075_L_Acme_Augusta: 484,
  Brick_075_L_Acme_Brookstone: 485,
  Brick_075_L_Acme_Callisburg: 845,
  Brick_075_L_Acme_CameronHills: 823,
  Brick_075_L_Acme_CasaBlanca: 775,
  Brick_075_L_Acme_CiboloTrail: 1799,
  Brick_075_L_Acme_CopperasCove: 1800,
  Brick_075_L_Acme_DentonAntique: 824,
  Brick_075_L_Acme_ForestHills: 543,
  Brick_075_L_Acme_FrenchChateaux: 597,
  Brick_075_L_Acme_Frostwood: 486,
  Brick_075_L_Acme_GlacierBay: 487,
  Brick_075_L_Acme_GlacierWhite: 1418,
  Brick_075_L_Acme_HamptonMill: 488,
  Brick_075_L_Acme_Highstone: 489,
  Brick_075_L_Acme_Inverness: 1387,
  Brick_075_L_Acme_Menawa: 1132,
  Brick_075_L_Acme_MochaBrownAntique: 598,
  Brick_075_L_Acme_MountainBrook: 490,
  Brick_075_L_Acme_MushroomBrown: 1133,
  Brick_075_L_Acme_OldFrancisco: 825,
  Brick_075_L_Acme_OldTavern: 1188,
  Brick_075_L_Acme_OxfordPlace: 1801,
  Brick_075_L_Acme_OysterBay: 491,
  Brick_075_L_Acme_ParkShadows: 492,
  Brick_075_L_Acme_PineRidge: 493,
  Brick_075_L_Acme_RapidFalls: 494,
  Brick_075_L_Acme_Redmont: 1736,
  Brick_075_L_Acme_Rockwell: 495,
  Brick_075_L_Acme_Saltgrass: 1317,
  Brick_075_L_Acme_SanJose: 544,
  Brick_075_L_Acme_Scottsdale: 496,
  Brick_075_L_Acme_Seabrook: 545,
  Brick_075_L_Acme_Shenandoah: 1357,
  Brick_075_L_Acme_Silvercreek: 776,
  Brick_075_L_Acme_Silverthorn: 497,
  Brick_075_L_Acme_SpanishBay: 1358,
  Brick_075_L_Acme_SpanishFort: 1737,
  Brick_075_L_Acme_StoneBay: 498,
  Brick_075_L_Acme_StoneLake: 1703,
  Brick_075_L_Acme_SummerSage: 1318,
  Brick_075_L_Acme_Texas: 1134,
  Brick_075_L_Acme_WhiteBirch: 1846,
  Brick_075_L_Acme_WhiteBluff: 1359,
  Brick_075_L_Acme_WhiteRiverRock: 499,
  Brick_075_L_Acme_Winterstone: 826,
  Brick_075_L_Belden_BlackDiamondVelour: 1419,
  Brick_075_L_Belden_GraphiteVelour: 1420,
  Brick_075_L_Bilco_Camel: 998,
  Brick_075_L_Bilco_Everest: 777,
  Brick_075_L_Bilco_GrayMist: 778,
  Brick_075_L_Bilco_Graystone: 999,
  Brick_075_L_Bilco_Onyx: 1000,
  Brick_075_L_Bilco_Phoenix: 1001,
  Brick_075_L_Bilco_Scottsdale: 779,
  Brick_075_L_Bilco_Stardust: 500,
  Brick_075_L_Binsa_AmericanAntique: 599,
  Brick_075_L_Binsa_EnglishDove: 1211,
  Brick_075_L_Binsa_HillStone: 600,
  Brick_075_L_Binsa_Monroe: 1581,
  Brick_075_L_Binsa_Smokey: 1582,
  Brick_075_L_CasaDaSassi_CdS_FullBrown: 149,
  Brick_075_L_Cherokee_Augusta: 150,
  Brick_075_L_Cherokee_Magnolia: 1237,
  Brick_075_L_Cherokee_Natchez: 151,
  Brick_075_L_Claymex_Alpine: 894,
  Brick_075_L_Claymex_Aspen: 1212,
  Brick_075_L_Claymex_Brownfield: 901,
  Brick_075_L_Claymex_Cobblestone: 908,
  Brick_075_L_Claymex_Keystone: 915,
  Brick_075_L_Claymex_LeMont: 356,
  Brick_075_L_Claymex_Onyx: 922,
  Brick_075_L_Claymex_Oxford: 357,
  Brick_075_L_Claymex_Pewter: 929,
  Brick_075_L_Claymex_UrbanaAntique: 1802,
  Brick_075_L_Claymex_Woodcreek: 936,
  Brick_075_L_Claymex_York: 943,
  Brick_075_L_Columbus_Charleston: 1738,
  Brick_075_L_Columbus_Georgetown: 1739,
  Brick_075_L_Columbus_MagnoliaBay: 1561,
  Brick_075_L_Columbus_OldBailey: 1740,
  Brick_075_L_Columbus_Ortega: 1741,
  Brick_075_L_Columbus_StoneChase: 1742,
  Brick_075_L_Columbus_Weracoba2: 1562,
  Brick_075_L_CommercialBrickCompany_CBC_ChandlerWhite: 1319,
  Brick_075_L_CommercialBrickCompany_CBC_CommercialAntique: 1803,
  Brick_075_L_CommercialBrickCompany_CBC_Hollister: 1320,
  Brick_075_L_FAKE_Chalk: 152,
  Brick_075_L_GeneralShale_GS_AlpineSelect: 627,
  Brick_075_L_GeneralShale_GS_Ashview: 382,
  Brick_075_L_GeneralShale_GS_BarnsleyTudor: 569,
  Brick_075_L_GeneralShale_GS_BourbonTrail: 324,
  Brick_075_L_GeneralShale_GS_BradfordHall: 1069,
  Brick_075_L_GeneralShale_GS_CapersIsland: 875,
  Brick_075_L_GeneralShale_GS_CavalryGray: 325,
  Brick_075_L_GeneralShale_GS_ClaytonFalls: 1090,
  Brick_075_L_GeneralShale_GS_ColonyPointe: 1687,
  Brick_075_L_GeneralShale_GS_Cortez: 1055,
  Brick_075_L_GeneralShale_GS_CumberlandTudor: 1688,
  Brick_075_L_GeneralShale_GS_Domino: 314,
  Brick_075_L_GeneralShale_GS_EnglishPub: 1638,
  Brick_075_L_GeneralShale_GS_Graymoor: 1076,
  Brick_075_L_GeneralShale_GS_Graysburg: 1444,
  Brick_075_L_GeneralShale_GS_HeritageTrail: 887,
  Brick_075_L_GeneralShale_GS_Ironworks: 1639,
  Brick_075_L_GeneralShale_GS_KeenelandElite: 570,
  Brick_075_L_GeneralShale_GS_ManorHouseTudor: 571,
  Brick_075_L_GeneralShale_GS_ModenaPaver: 1461,
  Brick_075_L_GeneralShale_GS_MorningSmoke: 1445,
  Brick_075_L_GeneralShale_GS_NewcastleGray: 641,
  Brick_075_L_GeneralShale_GS_NolinRiver: 326,
  Brick_075_L_GeneralShale_GS_OldEdisto: 647,
  Brick_075_L_GeneralShale_GS_OldEnglishTutor: 1446,
  Brick_075_L_GeneralShale_GS_Peppermill: 1640,
  Brick_075_L_GeneralShale_GS_RedColonial: 1097,
  Brick_075_L_GeneralShale_GS_ShadowGrey: 572,
  Brick_075_L_GeneralShale_GS_SpanishMoss: 856,
  Brick_075_L_GeneralShale_GS_StoneMountain: 876,
  Brick_075_L_GeneralShale_GS_SwanCreek: 340,
  Brick_075_L_GeneralShale_GS_Valor: 1118,
  Brick_075_L_GeneralShale_GS_VintagePort: 628,
  Brick_075_L_GeneralShale_GS_Winstar: 383,
  Brick_075_L_GeneralShale_GS_Winterhaven: 1486,
  Brick_075_L_GeneralShale_GS_Wynnewood: 629,
  Brick_075_L_GlenGery_Americano: 1641,
  Brick_075_L_GlenGery_AnthraciteSmooth: 1642,
  Brick_075_L_GlenGery_AntiqueWhite: 501,
  Brick_075_L_GlenGery_AspenWhite: 1643,
  Brick_075_L_GlenGery_AztecWhite: 502,
  Brick_075_L_GlenGery_BaxterBrownSmooth: 1644,
  Brick_075_L_GlenGery_Birch: 503,
  Brick_075_L_GlenGery_Casablanca: 504,
  Brick_075_L_GlenGery_ClassicCreamSmooth: 1645,
  Brick_075_L_GlenGery_RusticGrayWaterstruck: 1646,
  Brick_075_L_GlenGery_WilliamsburgBradford: 505,
  Brick_075_L_GlenGery_WilliamsburgCherryCreek: 506,
  Brick_075_L_GlenGery_WilliamsburgHampton: 507,
  Brick_075_L_Harristone_Charleston: 975,
  Brick_075_L_Harristone_DoveGrey: 976,
  Brick_075_L_Harristone_Midnight: 1542,
  Brick_075_L_Harristone_WhiteSand: 977,
  Brick_075_L_HenryBrick_HB_Avondale: 1543,
  Brick_075_L_HenryBrick_HB_CypressPoint: 341,
  Brick_075_L_Heritage_Ashwood: 1048,
  Brick_075_L_Lusco_PearlRiver: 508,
  Brick_075_L_Master_Chateau: 1804,
  Brick_075_L_Master_PortEdwards: 1805,
  Brick_075_L_Meridian_Alamo: 153,
  Brick_075_L_Meridian_AlpineSelect: 154,
  Brick_075_L_Meridian_Baytown: 155,
  Brick_075_L_Meridian_Belhaven: 156,
  Brick_075_L_Meridian_ChimneyMountain: 259,
  Brick_075_L_Meridian_Dover: 157,
  Brick_075_L_Meridian_FireOak: 1583,
  Brick_075_L_Meridian_Laredo: 158,
  Brick_075_L_Meridian_MtRushmore: 159,
  Brick_075_L_Meridian_NorthHighland: 160,
  Brick_075_L_Meridian_OldGuignard: 161,
  Brick_075_L_Meridian_OldJackson: 162,
  Brick_075_L_Meridian_PortHuron: 260,
  Brick_075_L_Meridian_SaltPlains: 163,
  Brick_075_L_Meridian_ShadowFalls: 164,
  Brick_075_L_Meridian_Smithsonian: 165,
  Brick_075_L_Meridian_StAndrews: 166,
  Brick_075_L_Meridian_StLorain: 167,
  Brick_075_L_Meridian_SummerAsh: 168,
  Brick_075_L_Meridian_WhiteHillstone: 1584,
  Brick_075_L_Meridian_WhiteRiverRock: 1585,
  Brick_075_L_Paint_SW_SW_6246_NorthStar: 169,
  Brick_075_L_Paint_SW_SW_7004_Snowbound: 305,
  Brick_075_L_Paint_SW_SW_7068_GrizzleGray: 170,
  Brick_075_L_Paint_SW_SW_9171_FeltedWool: 171,
  Brick_075_L_Paint_SW_SW_9174_MothWing: 172,
  Brick_075_L_PGH_Bark: 954,
  Brick_075_L_PGH_CharacterPutty: 955,
  Brick_075_L_PGH_CharacterRedRock: 956,
  Brick_075_L_PrestigeStone_PS_Farmhouse: 1268,
  Brick_075_L_ProVia_Boston: 1026,
  Brick_075_L_ProVia_Cobblestone: 1027,
  Brick_075_L_ProVia_Delaware: 1028,
  Brick_075_L_ProVia_Midnight: 1029,
  Brick_075_L_PVStone_Colonial: 1197,
  Brick_075_L_PVStone_Neptune: 1198,
  Brick_075_L_RedRiver_AlpineFog: 509,
  Brick_075_L_RedRiver_Amarylis: 510,
  Brick_075_L_RedRiver_BurlingtonAntique: 511,
  Brick_075_L_RedRiver_Caprock: 512,
  Brick_075_L_RedRiver_CrescentGrove: 513,
  Brick_075_L_RedRiver_CypressSprings: 514,
  Brick_075_L_RedRiver_FireOak: 515,
  Brick_075_L_RedRiver_FlintRanch: 1321,
  Brick_075_L_RedRiver_FoggyMorning: 780,
  Brick_075_L_RedRiver_Glenwood: 516,
  Brick_075_L_RedRiver_GlisteningSprings: 601,
  Brick_075_L_RedRiver_Madrono: 1704,
  Brick_075_L_RedRiver_Mayfield: 517,
  Brick_075_L_RedRiver_OzarkSmoke: 1322,
  Brick_075_L_RedRiver_Ridgemont: 518,
  Brick_075_L_RedRiver_SaltPlains: 519,
  Brick_075_L_RedRiver_ShadowFalls: 520,
  Brick_075_L_RedRiver_ShelteredBluff: 521,
  Brick_075_L_RedRiver_Silverado: 522,
  Brick_075_L_RedRiver_SnowMist: 781,
  Brick_075_L_RedRiver_SteelManor: 1806,
  Brick_075_L_RedRiver_SummerAsh: 1807,
  Brick_075_L_RedRiver_Tecomate: 523,
  Brick_075_L_RedRiver_WellsValley: 524,
  Brick_075_L_RedRiver_WhiteRiverRock: 782,
  Brick_075_L_Ryder_AntiqueWhite: 1360,
  Brick_075_L_Ryder_Casablanca: 1361,
  Brick_075_L_Spaulding_Onslow: 1544,
  Brick_075_L_Spaulding_YankeeHill: 1421,
  Brick_075_L_TexasStone_DarkGrayLuxbrick: 1400,
  Brick_075_L_TexasStone_OldTownLux: 1401,
  Brick_075_L_Triangle_BessemerGray: 173,
  Brick_075_L_Triangle_CapeFear: 1083,
  Brick_075_L_Triangle_ChesapeakeGrey: 1181,
  Brick_075_L_Triangle_DoverWhite: 374,
  Brick_075_L_Triangle_EvelynBay: 174,
  Brick_075_L_Triangle_FederalHill: 1159,
  Brick_075_L_Triangle_FortMill: 857,
  Brick_075_L_Triangle_JeffersonPark: 358,
  Brick_075_L_Triangle_KnobHill: 1743,
  Brick_075_L_Triangle_LibbyMill: 858,
  Brick_075_L_Triangle_MountainBranchSelect: 175,
  Brick_075_L_Triangle_Nantucket: 1104,
  Brick_075_L_Triangle_Northampton: 176,
  Brick_075_L_Triangle_Oakton: 1225,
  Brick_075_L_Triangle_OldColony: 177,
  Brick_075_L_Triangle_Oxford: 178,
  Brick_075_L_Triangle_Porter: 602,
  Brick_075_L_Triangle_Portsmouth: 1160,
  Brick_075_L_Triangle_RiverStreet: 1161,
  Brick_075_L_Triangle_SeelyTown: 359,
  Brick_075_L_Triangle_ShadowRidge: 1615,
  Brick_075_L_Triangle_SouthHampton: 179,
  Brick_075_L_Triangle_Wilmington: 1162,
  Brick_075_L_USBrick_Alamo: 1487,
  Brick_075_L_USBrick_AspenChase: 1488,
  Brick_075_L_USBrick_Belhaven: 1489,
  Brick_075_L_USBrick_BelleMeade: 1490,
  Brick_075_L_USBrick_Blackberry: 557,
  Brick_075_L_USBrick_Laredo: 1744,
  Brick_075_L_USBrick_Magnolia: 1269,
  Brick_075_L_USBrick_Monaco: 1062,
  Brick_075_L_USBrick_MtRushmore: 1491,
  Brick_075_L_USBrick_NatchezTrace: 1270,
  Brick_075_L_USBrick_Newcastle: 1492,
  Brick_075_L_USBrick_NorthHighland: 1493,
  Brick_075_L_USBrick_OldJackson: 1111,
  Brick_075_L_USBrick_OldOverton: 1494,
  Brick_075_L_USBrick_OldWaverly: 1226,
  Brick_075_L_USBrick_OysterCove: 1271,
  Brick_075_L_USBrick_ShadowStone: 1272,
  Brick_075_L_USBrick_StLorain: 1495,
  Brick_075_L_USBrick_TimberWood: 1273,
  Brick_075_L_USBrick_Twilight: 1608,
  Brick_075_L_USBrick_WeatheredWhite: 1705,
  Brick_Bracciano_Default: 52,
  BrickExecutive_L_Acme_Abbeville: 1252,
  BrickExecutive_L_Acme_AdenBlend: 1245,
  BrickExecutive_L_Acme_AdobeWells: 651,
  BrickExecutive_L_Acme_AnsleyPark: 1135,
  BrickExecutive_L_Acme_ArcticMist: 1388,
  BrickExecutive_L_Acme_AuburnHills: 1301,
  BrickExecutive_L_Acme_Augusta: 652,
  BrickExecutive_L_Acme_Brookstone: 653,
  BrickExecutive_L_Acme_Callisburg: 846,
  BrickExecutive_L_Acme_CameronHills: 827,
  BrickExecutive_L_Acme_CasaBlanca: 783,
  BrickExecutive_L_Acme_CiboloTrail: 1808,
  BrickExecutive_L_Acme_CopperasCove: 1809,
  BrickExecutive_L_Acme_DentonAntique: 828,
  BrickExecutive_L_Acme_ForestHills: 654,
  BrickExecutive_L_Acme_FrenchChateaux: 655,
  BrickExecutive_L_Acme_Frostwood: 656,
  BrickExecutive_L_Acme_GlacierBay: 657,
  BrickExecutive_L_Acme_GlacierWhite: 1422,
  BrickExecutive_L_Acme_HamptonMill: 658,
  BrickExecutive_L_Acme_Highstone: 659,
  BrickExecutive_L_Acme_Inverness: 1389,
  BrickExecutive_L_Acme_Menawa: 1136,
  BrickExecutive_L_Acme_MochaBrownAntique: 660,
  BrickExecutive_L_Acme_MountainBrook: 661,
  BrickExecutive_L_Acme_MushroomBrown: 1137,
  BrickExecutive_L_Acme_OldFrancisco: 829,
  BrickExecutive_L_Acme_OldTavern: 1189,
  BrickExecutive_L_Acme_OxfordPlace: 1810,
  BrickExecutive_L_Acme_OysterBay: 662,
  BrickExecutive_L_Acme_ParkShadows: 663,
  BrickExecutive_L_Acme_PineRidge: 664,
  BrickExecutive_L_Acme_RapidFalls: 665,
  BrickExecutive_L_Acme_Redmont: 1745,
  BrickExecutive_L_Acme_Rockwell: 666,
  BrickExecutive_L_Acme_Saltgrass: 1323,
  BrickExecutive_L_Acme_SanJose: 667,
  BrickExecutive_L_Acme_Scottsdale: 668,
  BrickExecutive_L_Acme_Seabrook: 669,
  BrickExecutive_L_Acme_Shenandoah: 1362,
  BrickExecutive_L_Acme_Silvercreek: 784,
  BrickExecutive_L_Acme_Silverthorn: 670,
  BrickExecutive_L_Acme_SpanishBay: 1363,
  BrickExecutive_L_Acme_SpanishFort: 1746,
  BrickExecutive_L_Acme_StoneBay: 671,
  BrickExecutive_L_Acme_StoneLake: 1706,
  BrickExecutive_L_Acme_SummerSage: 1324,
  BrickExecutive_L_Acme_Texas: 1138,
  BrickExecutive_L_Acme_WhiteBirch: 1847,
  BrickExecutive_L_Acme_WhiteBluff: 1364,
  BrickExecutive_L_Acme_WhiteRiverRock: 672,
  BrickExecutive_L_Acme_Winterstone: 830,
  BrickExecutive_L_Belden_BlackDiamondVelour: 1423,
  BrickExecutive_L_Belden_GraphiteVelour: 1424,
  BrickExecutive_L_Bilco_Camel: 1002,
  BrickExecutive_L_Bilco_Everest: 785,
  BrickExecutive_L_Bilco_GrayMist: 786,
  BrickExecutive_L_Bilco_Graystone: 1003,
  BrickExecutive_L_Bilco_Onyx: 1004,
  BrickExecutive_L_Bilco_Phoenix: 1005,
  BrickExecutive_L_Bilco_Scottsdale: 787,
  BrickExecutive_L_Bilco_Stardust: 673,
  BrickExecutive_L_Binsa_AmericanAntique: 674,
  BrickExecutive_L_Binsa_EnglishDove: 1213,
  BrickExecutive_L_Binsa_HillStone: 675,
  BrickExecutive_L_Binsa_Monroe: 1586,
  BrickExecutive_L_Binsa_Smokey: 1587,
  BrickExecutive_L_CasaDaSassi_CdS_FullBrown: 676,
  BrickExecutive_L_Cherokee_Augusta: 677,
  BrickExecutive_L_Cherokee_Magnolia: 1238,
  BrickExecutive_L_Cherokee_Natchez: 678,
  BrickExecutive_L_Claymex_Alpine: 895,
  BrickExecutive_L_Claymex_Aspen: 1214,
  BrickExecutive_L_Claymex_Brownfield: 902,
  BrickExecutive_L_Claymex_Cobblestone: 909,
  BrickExecutive_L_Claymex_Keystone: 916,
  BrickExecutive_L_Claymex_LeMont: 679,
  BrickExecutive_L_Claymex_Onyx: 923,
  BrickExecutive_L_Claymex_Oxford: 680,
  BrickExecutive_L_Claymex_Pewter: 930,
  BrickExecutive_L_Claymex_UrbanaAntique: 1811,
  BrickExecutive_L_Claymex_Woodcreek: 937,
  BrickExecutive_L_Claymex_York: 944,
  BrickExecutive_L_Columbus_Charleston: 1747,
  BrickExecutive_L_Columbus_Georgetown: 1748,
  BrickExecutive_L_Columbus_MagnoliaBay: 1563,
  BrickExecutive_L_Columbus_OldBailey: 1749,
  BrickExecutive_L_Columbus_Ortega: 1750,
  BrickExecutive_L_Columbus_StoneChase: 1751,
  BrickExecutive_L_Columbus_Weracoba2: 1564,
  BrickExecutive_L_CommercialBrickCompany_CBC_ChandlerWhite: 1325,
  BrickExecutive_L_CommercialBrickCompany_CBC_CommercialAntique: 1812,
  BrickExecutive_L_CommercialBrickCompany_CBC_Hollister: 1326,
  BrickExecutive_L_FAKE_Chalk: 681,
  BrickExecutive_L_GeneralShale_GS_AlpineSelect: 682,
  BrickExecutive_L_GeneralShale_GS_Ashview: 683,
  BrickExecutive_L_GeneralShale_GS_BarnsleyTudor: 684,
  BrickExecutive_L_GeneralShale_GS_BourbonTrail: 685,
  BrickExecutive_L_GeneralShale_GS_BradfordHall: 1070,
  BrickExecutive_L_GeneralShale_GS_CapersIsland: 877,
  BrickExecutive_L_GeneralShale_GS_CavalryGray: 686,
  BrickExecutive_L_GeneralShale_GS_ClaytonFalls: 1091,
  BrickExecutive_L_GeneralShale_GS_ColonyPointe: 1689,
  BrickExecutive_L_GeneralShale_GS_Cortez: 1056,
  BrickExecutive_L_GeneralShale_GS_CumberlandTudor: 1690,
  BrickExecutive_L_GeneralShale_GS_Domino: 687,
  BrickExecutive_L_GeneralShale_GS_EnglishPub: 1647,
  BrickExecutive_L_GeneralShale_GS_Graymoor: 1077,
  BrickExecutive_L_GeneralShale_GS_Graysburg: 1447,
  BrickExecutive_L_GeneralShale_GS_HeritageTrail: 888,
  BrickExecutive_L_GeneralShale_GS_Ironworks: 1648,
  BrickExecutive_L_GeneralShale_GS_KeenelandElite: 688,
  BrickExecutive_L_GeneralShale_GS_ManorHouseTudor: 689,
  BrickExecutive_L_GeneralShale_GS_ModenaPaver: 1462,
  BrickExecutive_L_GeneralShale_GS_MorningSmoke: 1448,
  BrickExecutive_L_GeneralShale_GS_NewcastleGray: 690,
  BrickExecutive_L_GeneralShale_GS_NolinRiver: 691,
  BrickExecutive_L_GeneralShale_GS_OldEdisto: 692,
  BrickExecutive_L_GeneralShale_GS_OldEnglishTutor: 1449,
  BrickExecutive_L_GeneralShale_GS_Peppermill: 1649,
  BrickExecutive_L_GeneralShale_GS_RedColonial: 1098,
  BrickExecutive_L_GeneralShale_GS_ShadowGrey: 693,
  BrickExecutive_L_GeneralShale_GS_SpanishMoss: 859,
  BrickExecutive_L_GeneralShale_GS_StoneMountain: 878,
  BrickExecutive_L_GeneralShale_GS_SwanCreek: 694,
  BrickExecutive_L_GeneralShale_GS_Valor: 1119,
  BrickExecutive_L_GeneralShale_GS_VintagePort: 695,
  BrickExecutive_L_GeneralShale_GS_Winstar: 696,
  BrickExecutive_L_GeneralShale_GS_Winterhaven: 1496,
  BrickExecutive_L_GeneralShale_GS_Wynnewood: 697,
  BrickExecutive_L_GlenGery_Americano: 1650,
  BrickExecutive_L_GlenGery_AnthraciteSmooth: 1651,
  BrickExecutive_L_GlenGery_AntiqueWhite: 698,
  BrickExecutive_L_GlenGery_AspenWhite: 1652,
  BrickExecutive_L_GlenGery_AztecWhite: 699,
  BrickExecutive_L_GlenGery_BaxterBrownSmooth: 1653,
  BrickExecutive_L_GlenGery_Birch: 700,
  BrickExecutive_L_GlenGery_Casablanca: 701,
  BrickExecutive_L_GlenGery_ClassicCreamSmooth: 1654,
  BrickExecutive_L_GlenGery_RusticGrayWaterstruck: 1655,
  BrickExecutive_L_GlenGery_WilliamsburgBradford: 702,
  BrickExecutive_L_GlenGery_WilliamsburgCherryCreek: 703,
  BrickExecutive_L_GlenGery_WilliamsburgHampton: 704,
  BrickExecutive_L_Harristone_Charleston: 978,
  BrickExecutive_L_Harristone_DoveGrey: 979,
  BrickExecutive_L_Harristone_Midnight: 1545,
  BrickExecutive_L_Harristone_WhiteSand: 980,
  BrickExecutive_L_HenryBrick_HB_Avondale: 1546,
  BrickExecutive_L_HenryBrick_HB_CypressPoint: 705,
  BrickExecutive_L_Heritage_Ashwood: 1049,
  BrickExecutive_L_Lusco_PearlRiver: 706,
  BrickExecutive_L_Master_Chateau: 1813,
  BrickExecutive_L_Master_PortEdwards: 1814,
  BrickExecutive_L_Meridian_Alamo: 707,
  BrickExecutive_L_Meridian_AlpineSelect: 708,
  BrickExecutive_L_Meridian_Baytown: 709,
  BrickExecutive_L_Meridian_Belhaven: 710,
  BrickExecutive_L_Meridian_ChimneyMountain: 711,
  BrickExecutive_L_Meridian_Dover: 712,
  BrickExecutive_L_Meridian_FireOak: 1588,
  BrickExecutive_L_Meridian_Laredo: 713,
  BrickExecutive_L_Meridian_MtRushmore: 714,
  BrickExecutive_L_Meridian_NorthHighland: 715,
  BrickExecutive_L_Meridian_OldGuignard: 716,
  BrickExecutive_L_Meridian_OldJackson: 717,
  BrickExecutive_L_Meridian_PortHuron: 718,
  BrickExecutive_L_Meridian_SaltPlains: 719,
  BrickExecutive_L_Meridian_ShadowFalls: 720,
  BrickExecutive_L_Meridian_Smithsonian: 721,
  BrickExecutive_L_Meridian_StAndrews: 722,
  BrickExecutive_L_Meridian_StLorain: 723,
  BrickExecutive_L_Meridian_SummerAsh: 724,
  BrickExecutive_L_Meridian_WhiteHillstone: 1589,
  BrickExecutive_L_Meridian_WhiteRiverRock: 1590,
  BrickExecutive_L_Paint_SW_SW_6246_NorthStar: 725,
  BrickExecutive_L_Paint_SW_SW_7004_Snowbound: 726,
  BrickExecutive_L_Paint_SW_SW_7068_GrizzleGray: 727,
  BrickExecutive_L_Paint_SW_SW_9171_FeltedWool: 728,
  BrickExecutive_L_Paint_SW_SW_9174_MothWing: 729,
  BrickExecutive_L_PGH_Bark: 957,
  BrickExecutive_L_PGH_CharacterPutty: 958,
  BrickExecutive_L_PGH_CharacterRedRock: 959,
  BrickExecutive_L_PrestigeStone_PS_Farmhouse: 1274,
  BrickExecutive_L_ProVia_Boston: 1030,
  BrickExecutive_L_ProVia_Cobblestone: 1031,
  BrickExecutive_L_ProVia_Delaware: 1032,
  BrickExecutive_L_ProVia_Midnight: 1033,
  BrickExecutive_L_PVStone_Colonial: 1199,
  BrickExecutive_L_PVStone_Neptune: 1200,
  BrickExecutive_L_RedRiver_AlpineFog: 730,
  BrickExecutive_L_RedRiver_Amarylis: 731,
  BrickExecutive_L_RedRiver_BurlingtonAntique: 732,
  BrickExecutive_L_RedRiver_Caprock: 733,
  BrickExecutive_L_RedRiver_CrescentGrove: 734,
  BrickExecutive_L_RedRiver_CypressSprings: 735,
  BrickExecutive_L_RedRiver_FireOak: 736,
  BrickExecutive_L_RedRiver_FlintRanch: 1327,
  BrickExecutive_L_RedRiver_FoggyMorning: 788,
  BrickExecutive_L_RedRiver_Glenwood: 737,
  BrickExecutive_L_RedRiver_GlisteningSprings: 738,
  BrickExecutive_L_RedRiver_Madrono: 1707,
  BrickExecutive_L_RedRiver_Mayfield: 739,
  BrickExecutive_L_RedRiver_OzarkSmoke: 1328,
  BrickExecutive_L_RedRiver_Ridgemont: 740,
  BrickExecutive_L_RedRiver_SaltPlains: 741,
  BrickExecutive_L_RedRiver_ShadowFalls: 742,
  BrickExecutive_L_RedRiver_ShelteredBluff: 743,
  BrickExecutive_L_RedRiver_Silverado: 744,
  BrickExecutive_L_RedRiver_SnowMist: 789,
  BrickExecutive_L_RedRiver_SteelManor: 1815,
  BrickExecutive_L_RedRiver_SummerAsh: 1816,
  BrickExecutive_L_RedRiver_Tecomate: 745,
  BrickExecutive_L_RedRiver_WellsValley: 746,
  BrickExecutive_L_RedRiver_WhiteRiverRock: 790,
  BrickExecutive_L_Ryder_AntiqueWhite: 1365,
  BrickExecutive_L_Ryder_Casablanca: 1366,
  BrickExecutive_L_Spaulding_Onslow: 1547,
  BrickExecutive_L_Spaulding_YankeeHill: 1425,
  BrickExecutive_L_TexasStone_DarkGrayLuxbrick: 1402,
  BrickExecutive_L_TexasStone_OldTownLux: 1403,
  BrickExecutive_L_Triangle_BessemerGray: 747,
  BrickExecutive_L_Triangle_CapeFear: 1084,
  BrickExecutive_L_Triangle_ChesapeakeGrey: 1182,
  BrickExecutive_L_Triangle_DoverWhite: 748,
  BrickExecutive_L_Triangle_EvelynBay: 749,
  BrickExecutive_L_Triangle_FederalHill: 1163,
  BrickExecutive_L_Triangle_FortMill: 860,
  BrickExecutive_L_Triangle_JeffersonPark: 750,
  BrickExecutive_L_Triangle_KnobHill: 1752,
  BrickExecutive_L_Triangle_LibbyMill: 861,
  BrickExecutive_L_Triangle_MountainBranchSelect: 751,
  BrickExecutive_L_Triangle_Nantucket: 1105,
  BrickExecutive_L_Triangle_Northampton: 752,
  BrickExecutive_L_Triangle_Oakton: 1227,
  BrickExecutive_L_Triangle_OldColony: 753,
  BrickExecutive_L_Triangle_Oxford: 754,
  BrickExecutive_L_Triangle_Porter: 755,
  BrickExecutive_L_Triangle_Portsmouth: 1164,
  BrickExecutive_L_Triangle_RiverStreet: 1165,
  BrickExecutive_L_Triangle_SeelyTown: 756,
  BrickExecutive_L_Triangle_ShadowRidge: 1616,
  BrickExecutive_L_Triangle_SouthHampton: 757,
  BrickExecutive_L_Triangle_Wilmington: 1166,
  BrickExecutive_L_USBrick_Alamo: 1497,
  BrickExecutive_L_USBrick_AspenChase: 1498,
  BrickExecutive_L_USBrick_Belhaven: 1499,
  BrickExecutive_L_USBrick_BelleMeade: 1500,
  BrickExecutive_L_USBrick_Blackberry: 758,
  BrickExecutive_L_USBrick_Laredo: 1753,
  BrickExecutive_L_USBrick_Magnolia: 1275,
  BrickExecutive_L_USBrick_Monaco: 1063,
  BrickExecutive_L_USBrick_MtRushmore: 1501,
  BrickExecutive_L_USBrick_NatchezTrace: 1276,
  BrickExecutive_L_USBrick_Newcastle: 1502,
  BrickExecutive_L_USBrick_NorthHighland: 1503,
  BrickExecutive_L_USBrick_OldJackson: 1112,
  BrickExecutive_L_USBrick_OldOverton: 1504,
  BrickExecutive_L_USBrick_OldWaverly: 1228,
  BrickExecutive_L_USBrick_OysterCove: 1277,
  BrickExecutive_L_USBrick_ShadowStone: 1278,
  BrickExecutive_L_USBrick_StLorain: 1505,
  BrickExecutive_L_USBrick_TimberWood: 1279,
  BrickExecutive_L_USBrick_Twilight: 1609,
  BrickExecutive_L_USBrick_WeatheredWhite: 1708,
  BrickKing_L_Acme_Abbeville: 1253,
  BrickKing_L_Acme_AdenBlend: 1246,
  BrickKing_L_Acme_AdobeWells: 180,
  BrickKing_L_Acme_AnsleyPark: 1139,
  BrickKing_L_Acme_ArcticMist: 1390,
  BrickKing_L_Acme_AuburnHills: 1302,
  BrickKing_L_Acme_Augusta: 267,
  BrickKing_L_Acme_Brookstone: 390,
  BrickKing_L_Acme_Callisburg: 847,
  BrickKing_L_Acme_CameronHills: 831,
  BrickKing_L_Acme_CasaBlanca: 791,
  BrickKing_L_Acme_CiboloTrail: 1817,
  BrickKing_L_Acme_CopperasCove: 1818,
  BrickKing_L_Acme_DentonAntique: 832,
  BrickKing_L_Acme_ForestHills: 546,
  BrickKing_L_Acme_FrenchChateaux: 603,
  BrickKing_L_Acme_Frostwood: 181,
  BrickKing_L_Acme_GlacierBay: 525,
  BrickKing_L_Acme_GlacierWhite: 1426,
  BrickKing_L_Acme_HamptonMill: 268,
  BrickKing_L_Acme_Highstone: 526,
  BrickKing_L_Acme_Inverness: 1391,
  BrickKing_L_Acme_Menawa: 1140,
  BrickKing_L_Acme_MochaBrownAntique: 604,
  BrickKing_L_Acme_MountainBrook: 391,
  BrickKing_L_Acme_MushroomBrown: 1141,
  BrickKing_L_Acme_OldFrancisco: 833,
  BrickKing_L_Acme_OldTavern: 1190,
  BrickKing_L_Acme_OxfordPlace: 1819,
  BrickKing_L_Acme_OysterBay: 269,
  BrickKing_L_Acme_ParkShadows: 182,
  BrickKing_L_Acme_PineRidge: 270,
  BrickKing_L_Acme_RapidFalls: 271,
  BrickKing_L_Acme_Redmont: 1754,
  BrickKing_L_Acme_Rockwell: 392,
  BrickKing_L_Acme_Saltgrass: 1329,
  BrickKing_L_Acme_SanJose: 547,
  BrickKing_L_Acme_Scottsdale: 272,
  BrickKing_L_Acme_Seabrook: 548,
  BrickKing_L_Acme_Shenandoah: 1367,
  BrickKing_L_Acme_Silvercreek: 792,
  BrickKing_L_Acme_Silverthorn: 183,
  BrickKing_L_Acme_SpanishBay: 1368,
  BrickKing_L_Acme_SpanishFort: 1755,
  BrickKing_L_Acme_StoneBay: 184,
  BrickKing_L_Acme_StoneLake: 1709,
  BrickKing_L_Acme_SummerSage: 1330,
  BrickKing_L_Acme_Texas: 1142,
  BrickKing_L_Acme_WhiteBirch: 1848,
  BrickKing_L_Acme_WhiteBluff: 1369,
  BrickKing_L_Acme_WhiteRiverRock: 527,
  BrickKing_L_Acme_Winterstone: 834,
  BrickKing_L_Belden_BlackDiamondVelour: 1427,
  BrickKing_L_Belden_GraphiteVelour: 1428,
  BrickKing_L_Bilco_Camel: 1006,
  BrickKing_L_Bilco_Everest: 793,
  BrickKing_L_Bilco_GrayMist: 794,
  BrickKing_L_Bilco_Graystone: 1007,
  BrickKing_L_Bilco_Onyx: 1008,
  BrickKing_L_Bilco_Phoenix: 1009,
  BrickKing_L_Bilco_Scottsdale: 795,
  BrickKing_L_Bilco_Stardust: 528,
  BrickKing_L_Binsa_AmericanAntique: 605,
  BrickKing_L_Binsa_EnglishDove: 1215,
  BrickKing_L_Binsa_HillStone: 606,
  BrickKing_L_Binsa_Monroe: 1591,
  BrickKing_L_Binsa_Smokey: 1592,
  BrickKing_L_CasaDaSassi_CdS_FullBrown: 109,
  BrickKing_L_Cherokee_Augusta: 53,
  BrickKing_L_Cherokee_Magnolia: 1239,
  BrickKing_L_Cherokee_Natchez: 54,
  BrickKing_L_Claymex_Alpine: 896,
  BrickKing_L_Claymex_Aspen: 1216,
  BrickKing_L_Claymex_Brownfield: 903,
  BrickKing_L_Claymex_Cobblestone: 910,
  BrickKing_L_Claymex_Keystone: 917,
  BrickKing_L_Claymex_LeMont: 360,
  BrickKing_L_Claymex_Onyx: 924,
  BrickKing_L_Claymex_Oxford: 361,
  BrickKing_L_Claymex_Pewter: 931,
  BrickKing_L_Claymex_UrbanaAntique: 1820,
  BrickKing_L_Claymex_Woodcreek: 938,
  BrickKing_L_Claymex_York: 945,
  BrickKing_L_Columbus_Charleston: 1756,
  BrickKing_L_Columbus_Georgetown: 1757,
  BrickKing_L_Columbus_MagnoliaBay: 1565,
  BrickKing_L_Columbus_OldBailey: 1758,
  BrickKing_L_Columbus_Ortega: 1759,
  BrickKing_L_Columbus_StoneChase: 1760,
  BrickKing_L_Columbus_Weracoba2: 1566,
  BrickKing_L_CommercialBrickCompany_CBC_ChandlerWhite: 1331,
  BrickKing_L_CommercialBrickCompany_CBC_CommercialAntique: 1821,
  BrickKing_L_CommercialBrickCompany_CBC_Hollister: 1332,
  BrickKing_L_FAKE_Chalk: 55,
  BrickKing_L_GeneralShale_GS_AlpineSelect: 630,
  BrickKing_L_GeneralShale_GS_Ashview: 384,
  BrickKing_L_GeneralShale_GS_BarnsleyTudor: 573,
  BrickKing_L_GeneralShale_GS_BourbonTrail: 327,
  BrickKing_L_GeneralShale_GS_BradfordHall: 1071,
  BrickKing_L_GeneralShale_GS_CapersIsland: 879,
  BrickKing_L_GeneralShale_GS_CavalryGray: 328,
  BrickKing_L_GeneralShale_GS_ClaytonFalls: 1092,
  BrickKing_L_GeneralShale_GS_ColonyPointe: 1691,
  BrickKing_L_GeneralShale_GS_Cortez: 1057,
  BrickKing_L_GeneralShale_GS_CumberlandTudor: 1692,
  BrickKing_L_GeneralShale_GS_Domino: 315,
  BrickKing_L_GeneralShale_GS_EnglishPub: 1656,
  BrickKing_L_GeneralShale_GS_Graymoor: 1078,
  BrickKing_L_GeneralShale_GS_Graysburg: 1450,
  BrickKing_L_GeneralShale_GS_HeritageTrail: 889,
  BrickKing_L_GeneralShale_GS_Ironworks: 1657,
  BrickKing_L_GeneralShale_GS_KeenelandElite: 574,
  BrickKing_L_GeneralShale_GS_ManorHouseTudor: 575,
  BrickKing_L_GeneralShale_GS_ModenaPaver: 1463,
  BrickKing_L_GeneralShale_GS_MorningSmoke: 1451,
  BrickKing_L_GeneralShale_GS_NewcastleGray: 642,
  BrickKing_L_GeneralShale_GS_NolinRiver: 329,
  BrickKing_L_GeneralShale_GS_OldEdisto: 648,
  BrickKing_L_GeneralShale_GS_OldEnglishTutor: 1452,
  BrickKing_L_GeneralShale_GS_Peppermill: 1658,
  BrickKing_L_GeneralShale_GS_RedColonial: 1099,
  BrickKing_L_GeneralShale_GS_ShadowGrey: 576,
  BrickKing_L_GeneralShale_GS_SpanishMoss: 862,
  BrickKing_L_GeneralShale_GS_StoneMountain: 880,
  BrickKing_L_GeneralShale_GS_SwanCreek: 342,
  BrickKing_L_GeneralShale_GS_Valor: 1120,
  BrickKing_L_GeneralShale_GS_VintagePort: 631,
  BrickKing_L_GeneralShale_GS_Winstar: 385,
  BrickKing_L_GeneralShale_GS_Winterhaven: 1506,
  BrickKing_L_GeneralShale_GS_Wynnewood: 632,
  BrickKing_L_GlenGery_Americano: 1659,
  BrickKing_L_GlenGery_AnthraciteSmooth: 1660,
  BrickKing_L_GlenGery_AntiqueWhite: 185,
  BrickKing_L_GlenGery_AspenWhite: 1661,
  BrickKing_L_GlenGery_AztecWhite: 186,
  BrickKing_L_GlenGery_BaxterBrownSmooth: 1662,
  BrickKing_L_GlenGery_Birch: 187,
  BrickKing_L_GlenGery_Casablanca: 188,
  BrickKing_L_GlenGery_ClassicCreamSmooth: 1663,
  BrickKing_L_GlenGery_RusticGrayWaterstruck: 1664,
  BrickKing_L_GlenGery_WilliamsburgBradford: 189,
  BrickKing_L_GlenGery_WilliamsburgCherryCreek: 190,
  BrickKing_L_GlenGery_WilliamsburgHampton: 191,
  BrickKing_L_Harristone_Charleston: 981,
  BrickKing_L_Harristone_DoveGrey: 982,
  BrickKing_L_Harristone_Midnight: 1548,
  BrickKing_L_Harristone_WhiteSand: 983,
  BrickKing_L_HenryBrick_HB_Avondale: 1549,
  BrickKing_L_HenryBrick_HB_CypressPoint: 343,
  BrickKing_L_Heritage_Ashwood: 1050,
  BrickKing_L_Lusco_PearlRiver: 249,
  BrickKing_L_Master_Chateau: 1822,
  BrickKing_L_Master_PortEdwards: 1823,
  BrickKing_L_Meridian_Alamo: 56,
  BrickKing_L_Meridian_AlpineSelect: 57,
  BrickKing_L_Meridian_Baytown: 58,
  BrickKing_L_Meridian_Belhaven: 59,
  BrickKing_L_Meridian_ChimneyMountain: 261,
  BrickKing_L_Meridian_Dover: 60,
  BrickKing_L_Meridian_FireOak: 1593,
  BrickKing_L_Meridian_Laredo: 61,
  BrickKing_L_Meridian_MtRushmore: 62,
  BrickKing_L_Meridian_NorthHighland: 63,
  BrickKing_L_Meridian_OldGuignard: 64,
  BrickKing_L_Meridian_OldJackson: 65,
  BrickKing_L_Meridian_PortHuron: 262,
  BrickKing_L_Meridian_SaltPlains: 66,
  BrickKing_L_Meridian_ShadowFalls: 67,
  BrickKing_L_Meridian_Smithsonian: 68,
  BrickKing_L_Meridian_StAndrews: 69,
  BrickKing_L_Meridian_StLorain: 70,
  BrickKing_L_Meridian_SummerAsh: 71,
  BrickKing_L_Meridian_WhiteHillstone: 1594,
  BrickKing_L_Meridian_WhiteRiverRock: 1595,
  BrickKing_L_Paint_SW_SW_6246_NorthStar: 192,
  BrickKing_L_Paint_SW_SW_7004_Snowbound: 306,
  BrickKing_L_Paint_SW_SW_7068_GrizzleGray: 72,
  BrickKing_L_Paint_SW_SW_9171_FeltedWool: 193,
  BrickKing_L_Paint_SW_SW_9174_MothWing: 194,
  BrickKing_L_PGH_Bark: 960,
  BrickKing_L_PGH_CharacterPutty: 961,
  BrickKing_L_PGH_CharacterRedRock: 962,
  BrickKing_L_PrestigeStone_PS_Farmhouse: 1280,
  BrickKing_L_ProVia_Boston: 1034,
  BrickKing_L_ProVia_Cobblestone: 1035,
  BrickKing_L_ProVia_Delaware: 1036,
  BrickKing_L_ProVia_Midnight: 1037,
  BrickKing_L_PVStone_Colonial: 1201,
  BrickKing_L_PVStone_Neptune: 1202,
  BrickKing_L_RedRiver_AlpineFog: 195,
  BrickKing_L_RedRiver_Amarylis: 309,
  BrickKing_L_RedRiver_BurlingtonAntique: 285,
  BrickKing_L_RedRiver_Caprock: 286,
  BrickKing_L_RedRiver_CrescentGrove: 196,
  BrickKing_L_RedRiver_CypressSprings: 287,
  BrickKing_L_RedRiver_FireOak: 197,
  BrickKing_L_RedRiver_FlintRanch: 1333,
  BrickKing_L_RedRiver_FoggyMorning: 796,
  BrickKing_L_RedRiver_Glenwood: 198,
  BrickKing_L_RedRiver_GlisteningSprings: 607,
  BrickKing_L_RedRiver_Madrono: 1710,
  BrickKing_L_RedRiver_Mayfield: 288,
  BrickKing_L_RedRiver_OzarkSmoke: 1334,
  BrickKing_L_RedRiver_Ridgemont: 289,
  BrickKing_L_RedRiver_SaltPlains: 199,
  BrickKing_L_RedRiver_ShadowFalls: 200,
  BrickKing_L_RedRiver_ShelteredBluff: 201,
  BrickKing_L_RedRiver_Silverado: 290,
  BrickKing_L_RedRiver_SnowMist: 797,
  BrickKing_L_RedRiver_SteelManor: 1824,
  BrickKing_L_RedRiver_SummerAsh: 1825,
  BrickKing_L_RedRiver_Tecomate: 202,
  BrickKing_L_RedRiver_WellsValley: 250,
  BrickKing_L_RedRiver_WhiteRiverRock: 798,
  BrickKing_L_Ryder_AntiqueWhite: 1370,
  BrickKing_L_Ryder_Casablanca: 1371,
  BrickKing_L_Spaulding_Onslow: 1550,
  BrickKing_L_Spaulding_YankeeHill: 1429,
  BrickKing_L_TexasStone_DarkGrayLuxbrick: 1404,
  BrickKing_L_TexasStone_OldTownLux: 1405,
  BrickKing_L_Triangle_BessemerGray: 73,
  BrickKing_L_Triangle_CapeFear: 1085,
  BrickKing_L_Triangle_ChesapeakeGrey: 1183,
  BrickKing_L_Triangle_DoverWhite: 375,
  BrickKing_L_Triangle_EvelynBay: 74,
  BrickKing_L_Triangle_FederalHill: 1167,
  BrickKing_L_Triangle_FortMill: 863,
  BrickKing_L_Triangle_JeffersonPark: 362,
  BrickKing_L_Triangle_KnobHill: 1761,
  BrickKing_L_Triangle_LibbyMill: 864,
  BrickKing_L_Triangle_MountainBranchSelect: 75,
  BrickKing_L_Triangle_Nantucket: 1106,
  BrickKing_L_Triangle_Northampton: 110,
  BrickKing_L_Triangle_Oakton: 1229,
  BrickKing_L_Triangle_OldColony: 111,
  BrickKing_L_Triangle_Oxford: 76,
  BrickKing_L_Triangle_Porter: 608,
  BrickKing_L_Triangle_Portsmouth: 1168,
  BrickKing_L_Triangle_RiverStreet: 1169,
  BrickKing_L_Triangle_SeelyTown: 363,
  BrickKing_L_Triangle_ShadowRidge: 1617,
  BrickKing_L_Triangle_SouthHampton: 77,
  BrickKing_L_Triangle_Wilmington: 1170,
  BrickKing_L_USBrick_Alamo: 1507,
  BrickKing_L_USBrick_AspenChase: 1508,
  BrickKing_L_USBrick_Belhaven: 1509,
  BrickKing_L_USBrick_BelleMeade: 1510,
  BrickKing_L_USBrick_Blackberry: 558,
  BrickKing_L_USBrick_Laredo: 1762,
  BrickKing_L_USBrick_Magnolia: 1281,
  BrickKing_L_USBrick_Monaco: 1064,
  BrickKing_L_USBrick_MtRushmore: 1511,
  BrickKing_L_USBrick_NatchezTrace: 1282,
  BrickKing_L_USBrick_Newcastle: 1512,
  BrickKing_L_USBrick_NorthHighland: 1513,
  BrickKing_L_USBrick_OldJackson: 1113,
  BrickKing_L_USBrick_OldOverton: 1514,
  BrickKing_L_USBrick_OldWaverly: 1230,
  BrickKing_L_USBrick_OysterCove: 1283,
  BrickKing_L_USBrick_ShadowStone: 1284,
  BrickKing_L_USBrick_StLorain: 1515,
  BrickKing_L_USBrick_TimberWood: 1285,
  BrickKing_L_USBrick_Twilight: 1610,
  BrickKing_L_USBrick_WeatheredWhite: 1711,
  BrickModular_L_Acme_Abbeville: 1254,
  BrickModular_L_Acme_AdenBlend: 1247,
  BrickModular_L_Acme_AdobeWells: 203,
  BrickModular_L_Acme_AnsleyPark: 1143,
  BrickModular_L_Acme_ArcticMist: 1392,
  BrickModular_L_Acme_AuburnHills: 1303,
  BrickModular_L_Acme_Augusta: 273,
  BrickModular_L_Acme_Brookstone: 393,
  BrickModular_L_Acme_Callisburg: 848,
  BrickModular_L_Acme_CameronHills: 835,
  BrickModular_L_Acme_CasaBlanca: 799,
  BrickModular_L_Acme_CiboloTrail: 1826,
  BrickModular_L_Acme_CopperasCove: 1827,
  BrickModular_L_Acme_DentonAntique: 836,
  BrickModular_L_Acme_ForestHills: 549,
  BrickModular_L_Acme_FrenchChateaux: 609,
  BrickModular_L_Acme_Frostwood: 204,
  BrickModular_L_Acme_GlacierBay: 529,
  BrickModular_L_Acme_GlacierWhite: 1430,
  BrickModular_L_Acme_HamptonMill: 274,
  BrickModular_L_Acme_Highstone: 530,
  BrickModular_L_Acme_Inverness: 1393,
  BrickModular_L_Acme_Menawa: 1144,
  BrickModular_L_Acme_MochaBrownAntique: 610,
  BrickModular_L_Acme_MountainBrook: 394,
  BrickModular_L_Acme_MushroomBrown: 1145,
  BrickModular_L_Acme_OldFrancisco: 837,
  BrickModular_L_Acme_OldTavern: 1191,
  BrickModular_L_Acme_OxfordPlace: 1828,
  BrickModular_L_Acme_OysterBay: 275,
  BrickModular_L_Acme_ParkShadows: 205,
  BrickModular_L_Acme_PineRidge: 276,
  BrickModular_L_Acme_RapidFalls: 277,
  BrickModular_L_Acme_Redmont: 1763,
  BrickModular_L_Acme_Rockwell: 395,
  BrickModular_L_Acme_Saltgrass: 1335,
  BrickModular_L_Acme_SanJose: 550,
  BrickModular_L_Acme_Scottsdale: 278,
  BrickModular_L_Acme_Seabrook: 551,
  BrickModular_L_Acme_Shenandoah: 1372,
  BrickModular_L_Acme_Silvercreek: 800,
  BrickModular_L_Acme_Silverthorn: 206,
  BrickModular_L_Acme_SpanishBay: 1373,
  BrickModular_L_Acme_SpanishFort: 1764,
  BrickModular_L_Acme_StoneBay: 207,
  BrickModular_L_Acme_StoneLake: 1712,
  BrickModular_L_Acme_SummerSage: 1336,
  BrickModular_L_Acme_Texas: 1146,
  BrickModular_L_Acme_WhiteBirch: 1849,
  BrickModular_L_Acme_WhiteBluff: 1374,
  BrickModular_L_Acme_WhiteRiverRock: 531,
  BrickModular_L_Acme_Winterstone: 838,
  BrickModular_L_Belden_BlackDiamondVelour: 1431,
  BrickModular_L_Belden_GraphiteVelour: 1432,
  BrickModular_L_Bilco_Camel: 1010,
  BrickModular_L_Bilco_Everest: 801,
  BrickModular_L_Bilco_GrayMist: 802,
  BrickModular_L_Bilco_Graystone: 1011,
  BrickModular_L_Bilco_Onyx: 1012,
  BrickModular_L_Bilco_Phoenix: 1013,
  BrickModular_L_Bilco_Scottsdale: 803,
  BrickModular_L_Bilco_Stardust: 532,
  BrickModular_L_Binsa_AmericanAntique: 611,
  BrickModular_L_Binsa_EnglishDove: 1217,
  BrickModular_L_Binsa_HillStone: 612,
  BrickModular_L_Binsa_Monroe: 1596,
  BrickModular_L_Binsa_Smokey: 1597,
  BrickModular_L_CasaDaSassi_CdS_FullBrown: 112,
  BrickModular_L_Cherokee_Augusta: 113,
  BrickModular_L_Cherokee_Magnolia: 1240,
  BrickModular_L_Cherokee_Natchez: 114,
  BrickModular_L_Claymex_Alpine: 897,
  BrickModular_L_Claymex_Aspen: 1218,
  BrickModular_L_Claymex_Brownfield: 904,
  BrickModular_L_Claymex_Cobblestone: 911,
  BrickModular_L_Claymex_Keystone: 918,
  BrickModular_L_Claymex_LeMont: 364,
  BrickModular_L_Claymex_Onyx: 925,
  BrickModular_L_Claymex_Oxford: 365,
  BrickModular_L_Claymex_Pewter: 932,
  BrickModular_L_Claymex_UrbanaAntique: 1829,
  BrickModular_L_Claymex_Woodcreek: 939,
  BrickModular_L_Claymex_York: 946,
  BrickModular_L_Columbus_Charleston: 1765,
  BrickModular_L_Columbus_Georgetown: 1766,
  BrickModular_L_Columbus_MagnoliaBay: 1567,
  BrickModular_L_Columbus_OldBailey: 1767,
  BrickModular_L_Columbus_Ortega: 1768,
  BrickModular_L_Columbus_StoneChase: 1769,
  BrickModular_L_Columbus_Weracoba2: 1568,
  BrickModular_L_CommercialBrickCompany_CBC_ChandlerWhite: 1337,
  BrickModular_L_CommercialBrickCompany_CBC_CommercialAntique: 1830,
  BrickModular_L_CommercialBrickCompany_CBC_Hollister: 1338,
  BrickModular_L_FAKE_Chalk: 115,
  BrickModular_L_GeneralShale_GS_AlpineSelect: 633,
  BrickModular_L_GeneralShale_GS_Ashview: 386,
  BrickModular_L_GeneralShale_GS_BarnsleyTudor: 577,
  BrickModular_L_GeneralShale_GS_BourbonTrail: 330,
  BrickModular_L_GeneralShale_GS_BradfordHall: 1072,
  BrickModular_L_GeneralShale_GS_CapersIsland: 881,
  BrickModular_L_GeneralShale_GS_CavalryGray: 331,
  BrickModular_L_GeneralShale_GS_ClaytonFalls: 1093,
  BrickModular_L_GeneralShale_GS_ColonyPointe: 1693,
  BrickModular_L_GeneralShale_GS_Cortez: 1058,
  BrickModular_L_GeneralShale_GS_CumberlandTudor: 1694,
  BrickModular_L_GeneralShale_GS_Domino: 316,
  BrickModular_L_GeneralShale_GS_EnglishPub: 1665,
  BrickModular_L_GeneralShale_GS_Graymoor: 1079,
  BrickModular_L_GeneralShale_GS_Graysburg: 1453,
  BrickModular_L_GeneralShale_GS_HeritageTrail: 890,
  BrickModular_L_GeneralShale_GS_Ironworks: 1666,
  BrickModular_L_GeneralShale_GS_KeenelandElite: 578,
  BrickModular_L_GeneralShale_GS_ManorHouseTudor: 579,
  BrickModular_L_GeneralShale_GS_ModenaPaver: 1464,
  BrickModular_L_GeneralShale_GS_MorningSmoke: 1454,
  BrickModular_L_GeneralShale_GS_NewcastleGray: 643,
  BrickModular_L_GeneralShale_GS_NolinRiver: 332,
  BrickModular_L_GeneralShale_GS_OldEdisto: 649,
  BrickModular_L_GeneralShale_GS_OldEnglishTutor: 1455,
  BrickModular_L_GeneralShale_GS_Peppermill: 1667,
  BrickModular_L_GeneralShale_GS_RedColonial: 1100,
  BrickModular_L_GeneralShale_GS_ShadowGrey: 580,
  BrickModular_L_GeneralShale_GS_SpanishMoss: 865,
  BrickModular_L_GeneralShale_GS_StoneMountain: 882,
  BrickModular_L_GeneralShale_GS_SwanCreek: 344,
  BrickModular_L_GeneralShale_GS_Valor: 1121,
  BrickModular_L_GeneralShale_GS_VintagePort: 634,
  BrickModular_L_GeneralShale_GS_Winstar: 387,
  BrickModular_L_GeneralShale_GS_Winterhaven: 1516,
  BrickModular_L_GeneralShale_GS_Wynnewood: 635,
  BrickModular_L_GlenGery_Americano: 1668,
  BrickModular_L_GlenGery_AnthraciteSmooth: 1669,
  BrickModular_L_GlenGery_AntiqueWhite: 208,
  BrickModular_L_GlenGery_AspenWhite: 1670,
  BrickModular_L_GlenGery_AztecWhite: 209,
  BrickModular_L_GlenGery_BaxterBrownSmooth: 1671,
  BrickModular_L_GlenGery_Birch: 210,
  BrickModular_L_GlenGery_Casablanca: 211,
  BrickModular_L_GlenGery_ClassicCreamSmooth: 1672,
  BrickModular_L_GlenGery_RusticGrayWaterstruck: 1673,
  BrickModular_L_GlenGery_WilliamsburgBradford: 212,
  BrickModular_L_GlenGery_WilliamsburgCherryCreek: 213,
  BrickModular_L_GlenGery_WilliamsburgHampton: 214,
  BrickModular_L_Harristone_Charleston: 984,
  BrickModular_L_Harristone_DoveGrey: 985,
  BrickModular_L_Harristone_Midnight: 1551,
  BrickModular_L_Harristone_WhiteSand: 986,
  BrickModular_L_HenryBrick_HB_Avondale: 1552,
  BrickModular_L_HenryBrick_HB_CypressPoint: 345,
  BrickModular_L_Heritage_Ashwood: 1051,
  BrickModular_L_Lusco_PearlRiver: 251,
  BrickModular_L_Master_Chateau: 1831,
  BrickModular_L_Master_PortEdwards: 1832,
  BrickModular_L_Meridian_Alamo: 116,
  BrickModular_L_Meridian_AlpineSelect: 117,
  BrickModular_L_Meridian_Baytown: 118,
  BrickModular_L_Meridian_Belhaven: 119,
  BrickModular_L_Meridian_ChimneyMountain: 263,
  BrickModular_L_Meridian_Dover: 120,
  BrickModular_L_Meridian_FireOak: 1598,
  BrickModular_L_Meridian_Laredo: 121,
  BrickModular_L_Meridian_MtRushmore: 122,
  BrickModular_L_Meridian_NorthHighland: 123,
  BrickModular_L_Meridian_OldGuignard: 124,
  BrickModular_L_Meridian_OldJackson: 125,
  BrickModular_L_Meridian_PortHuron: 264,
  BrickModular_L_Meridian_SaltPlains: 126,
  BrickModular_L_Meridian_ShadowFalls: 127,
  BrickModular_L_Meridian_Smithsonian: 128,
  BrickModular_L_Meridian_StAndrews: 129,
  BrickModular_L_Meridian_StLorain: 130,
  BrickModular_L_Meridian_SummerAsh: 131,
  BrickModular_L_Meridian_WhiteHillstone: 1599,
  BrickModular_L_Meridian_WhiteRiverRock: 1600,
  BrickModular_L_Paint_SW_SW_6246_NorthStar: 215,
  BrickModular_L_Paint_SW_SW_7004_Snowbound: 307,
  BrickModular_L_Paint_SW_SW_7068_GrizzleGray: 132,
  BrickModular_L_Paint_SW_SW_9171_FeltedWool: 216,
  BrickModular_L_Paint_SW_SW_9174_MothWing: 217,
  BrickModular_L_PGH_Bark: 963,
  BrickModular_L_PGH_CharacterPutty: 964,
  BrickModular_L_PGH_CharacterRedRock: 965,
  BrickModular_L_PrestigeStone_PS_Farmhouse: 1286,
  BrickModular_L_ProVia_Boston: 1038,
  BrickModular_L_ProVia_Cobblestone: 1039,
  BrickModular_L_ProVia_Delaware: 1040,
  BrickModular_L_ProVia_Midnight: 1041,
  BrickModular_L_PVStone_Colonial: 1203,
  BrickModular_L_PVStone_Neptune: 1204,
  BrickModular_L_RedRiver_AlpineFog: 218,
  BrickModular_L_RedRiver_Amarylis: 310,
  BrickModular_L_RedRiver_BurlingtonAntique: 291,
  BrickModular_L_RedRiver_Caprock: 292,
  BrickModular_L_RedRiver_CrescentGrove: 219,
  BrickModular_L_RedRiver_CypressSprings: 293,
  BrickModular_L_RedRiver_FireOak: 220,
  BrickModular_L_RedRiver_FlintRanch: 1339,
  BrickModular_L_RedRiver_FoggyMorning: 804,
  BrickModular_L_RedRiver_Glenwood: 221,
  BrickModular_L_RedRiver_GlisteningSprings: 613,
  BrickModular_L_RedRiver_Madrono: 1713,
  BrickModular_L_RedRiver_Mayfield: 294,
  BrickModular_L_RedRiver_OzarkSmoke: 1340,
  BrickModular_L_RedRiver_Ridgemont: 295,
  BrickModular_L_RedRiver_SaltPlains: 222,
  BrickModular_L_RedRiver_ShadowFalls: 223,
  BrickModular_L_RedRiver_ShelteredBluff: 224,
  BrickModular_L_RedRiver_Silverado: 296,
  BrickModular_L_RedRiver_SnowMist: 805,
  BrickModular_L_RedRiver_SteelManor: 1833,
  BrickModular_L_RedRiver_SummerAsh: 1834,
  BrickModular_L_RedRiver_Tecomate: 225,
  BrickModular_L_RedRiver_WellsValley: 252,
  BrickModular_L_RedRiver_WhiteRiverRock: 806,
  BrickModular_L_Ryder_AntiqueWhite: 1375,
  BrickModular_L_Ryder_Casablanca: 1376,
  BrickModular_L_Spaulding_Onslow: 1553,
  BrickModular_L_Spaulding_YankeeHill: 1433,
  BrickModular_L_TexasStone_DarkGrayLuxbrick: 1406,
  BrickModular_L_TexasStone_OldTownLux: 1407,
  BrickModular_L_Triangle_BessemerGray: 133,
  BrickModular_L_Triangle_CapeFear: 1086,
  BrickModular_L_Triangle_ChesapeakeGrey: 1184,
  BrickModular_L_Triangle_DoverWhite: 376,
  BrickModular_L_Triangle_EvelynBay: 134,
  BrickModular_L_Triangle_FederalHill: 1171,
  BrickModular_L_Triangle_FortMill: 866,
  BrickModular_L_Triangle_JeffersonPark: 366,
  BrickModular_L_Triangle_KnobHill: 1770,
  BrickModular_L_Triangle_LibbyMill: 867,
  BrickModular_L_Triangle_MountainBranchSelect: 135,
  BrickModular_L_Triangle_Nantucket: 1107,
  BrickModular_L_Triangle_Northampton: 136,
  BrickModular_L_Triangle_Oakton: 1231,
  BrickModular_L_Triangle_OldColony: 137,
  BrickModular_L_Triangle_Oxford: 138,
  BrickModular_L_Triangle_Porter: 614,
  BrickModular_L_Triangle_Portsmouth: 1172,
  BrickModular_L_Triangle_RiverStreet: 1173,
  BrickModular_L_Triangle_SeelyTown: 367,
  BrickModular_L_Triangle_ShadowRidge: 1618,
  BrickModular_L_Triangle_SouthHampton: 139,
  BrickModular_L_Triangle_Wilmington: 1174,
  BrickModular_L_USBrick_Alamo: 1517,
  BrickModular_L_USBrick_AspenChase: 1518,
  BrickModular_L_USBrick_Belhaven: 1519,
  BrickModular_L_USBrick_BelleMeade: 1520,
  BrickModular_L_USBrick_Blackberry: 559,
  BrickModular_L_USBrick_Laredo: 1771,
  BrickModular_L_USBrick_Magnolia: 1287,
  BrickModular_L_USBrick_Monaco: 1065,
  BrickModular_L_USBrick_MtRushmore: 1521,
  BrickModular_L_USBrick_NatchezTrace: 1288,
  BrickModular_L_USBrick_Newcastle: 1522,
  BrickModular_L_USBrick_NorthHighland: 1523,
  BrickModular_L_USBrick_OldJackson: 1114,
  BrickModular_L_USBrick_OldOverton: 1524,
  BrickModular_L_USBrick_OldWaverly: 1232,
  BrickModular_L_USBrick_OysterCove: 1289,
  BrickModular_L_USBrick_ShadowStone: 1290,
  BrickModular_L_USBrick_StLorain: 1525,
  BrickModular_L_USBrick_TimberWood: 1291,
  BrickModular_L_USBrick_Twilight: 1611,
  BrickModular_L_USBrick_WeatheredWhite: 1714,
  BrickQueen_L_Acme_Abbeville: 1255,
  BrickQueen_L_Acme_AdenBlend: 1248,
  BrickQueen_L_Acme_AdobeWells: 226,
  BrickQueen_L_Acme_AnsleyPark: 1147,
  BrickQueen_L_Acme_ArcticMist: 1394,
  BrickQueen_L_Acme_AuburnHills: 1304,
  BrickQueen_L_Acme_Augusta: 279,
  BrickQueen_L_Acme_Brookstone: 396,
  BrickQueen_L_Acme_Callisburg: 849,
  BrickQueen_L_Acme_CameronHills: 839,
  BrickQueen_L_Acme_CasaBlanca: 807,
  BrickQueen_L_Acme_CiboloTrail: 1835,
  BrickQueen_L_Acme_CopperasCove: 1836,
  BrickQueen_L_Acme_DentonAntique: 840,
  BrickQueen_L_Acme_ForestHills: 552,
  BrickQueen_L_Acme_FrenchChateaux: 615,
  BrickQueen_L_Acme_Frostwood: 227,
  BrickQueen_L_Acme_GlacierBay: 533,
  BrickQueen_L_Acme_GlacierWhite: 1434,
  BrickQueen_L_Acme_HamptonMill: 280,
  BrickQueen_L_Acme_Highstone: 534,
  BrickQueen_L_Acme_Inverness: 1395,
  BrickQueen_L_Acme_Menawa: 1148,
  BrickQueen_L_Acme_MochaBrownAntique: 616,
  BrickQueen_L_Acme_MountainBrook: 397,
  BrickQueen_L_Acme_MushroomBrown: 1149,
  BrickQueen_L_Acme_OldFrancisco: 841,
  BrickQueen_L_Acme_OldTavern: 1192,
  BrickQueen_L_Acme_OxfordPlace: 1837,
  BrickQueen_L_Acme_OysterBay: 281,
  BrickQueen_L_Acme_ParkShadows: 228,
  BrickQueen_L_Acme_PineRidge: 282,
  BrickQueen_L_Acme_RapidFalls: 283,
  BrickQueen_L_Acme_Redmont: 1772,
  BrickQueen_L_Acme_Rockwell: 398,
  BrickQueen_L_Acme_Saltgrass: 1341,
  BrickQueen_L_Acme_SanJose: 553,
  BrickQueen_L_Acme_Scottsdale: 284,
  BrickQueen_L_Acme_Seabrook: 554,
  BrickQueen_L_Acme_Shenandoah: 1377,
  BrickQueen_L_Acme_Silvercreek: 808,
  BrickQueen_L_Acme_Silverthorn: 229,
  BrickQueen_L_Acme_SpanishBay: 1378,
  BrickQueen_L_Acme_SpanishFort: 1773,
  BrickQueen_L_Acme_StoneBay: 230,
  BrickQueen_L_Acme_StoneLake: 1715,
  BrickQueen_L_Acme_SummerSage: 1342,
  BrickQueen_L_Acme_Texas: 1150,
  BrickQueen_L_Acme_WhiteBirch: 1850,
  BrickQueen_L_Acme_WhiteBluff: 1379,
  BrickQueen_L_Acme_WhiteRiverRock: 535,
  BrickQueen_L_Acme_Winterstone: 842,
  BrickQueen_L_Belden_BlackDiamondVelour: 1435,
  BrickQueen_L_Belden_GraphiteVelour: 1436,
  BrickQueen_L_Bilco_Camel: 1014,
  BrickQueen_L_Bilco_Everest: 809,
  BrickQueen_L_Bilco_GrayMist: 810,
  BrickQueen_L_Bilco_Graystone: 1015,
  BrickQueen_L_Bilco_Onyx: 1016,
  BrickQueen_L_Bilco_Phoenix: 1017,
  BrickQueen_L_Bilco_Scottsdale: 811,
  BrickQueen_L_Bilco_Stardust: 536,
  BrickQueen_L_Binsa_AmericanAntique: 617,
  BrickQueen_L_Binsa_EnglishDove: 1219,
  BrickQueen_L_Binsa_HillStone: 618,
  BrickQueen_L_Binsa_Monroe: 1601,
  BrickQueen_L_Binsa_Smokey: 1602,
  BrickQueen_L_CasaDaSassi_CdS_FullBrown: 140,
  BrickQueen_L_Cherokee_Augusta: 78,
  BrickQueen_L_Cherokee_Magnolia: 1241,
  BrickQueen_L_Cherokee_Natchez: 79,
  BrickQueen_L_Claymex_Alpine: 898,
  BrickQueen_L_Claymex_Aspen: 1220,
  BrickQueen_L_Claymex_Brownfield: 905,
  BrickQueen_L_Claymex_Cobblestone: 912,
  BrickQueen_L_Claymex_Keystone: 919,
  BrickQueen_L_Claymex_LeMont: 368,
  BrickQueen_L_Claymex_Onyx: 926,
  BrickQueen_L_Claymex_Oxford: 369,
  BrickQueen_L_Claymex_Pewter: 933,
  BrickQueen_L_Claymex_UrbanaAntique: 1838,
  BrickQueen_L_Claymex_Woodcreek: 940,
  BrickQueen_L_Claymex_York: 947,
  BrickQueen_L_Columbus_Charleston: 1774,
  BrickQueen_L_Columbus_Georgetown: 1775,
  BrickQueen_L_Columbus_MagnoliaBay: 1569,
  BrickQueen_L_Columbus_OldBailey: 1776,
  BrickQueen_L_Columbus_Ortega: 1777,
  BrickQueen_L_Columbus_StoneChase: 1778,
  BrickQueen_L_Columbus_Weracoba2: 1570,
  BrickQueen_L_CommercialBrickCompany_CBC_ChandlerWhite: 1343,
  BrickQueen_L_CommercialBrickCompany_CBC_CommercialAntique: 1839,
  BrickQueen_L_CommercialBrickCompany_CBC_Hollister: 1344,
  BrickQueen_L_FAKE_Chalk: 80,
  BrickQueen_L_GeneralShale_GS_AlpineSelect: 636,
  BrickQueen_L_GeneralShale_GS_Ashview: 388,
  BrickQueen_L_GeneralShale_GS_BarnsleyTudor: 581,
  BrickQueen_L_GeneralShale_GS_BourbonTrail: 333,
  BrickQueen_L_GeneralShale_GS_BradfordHall: 1073,
  BrickQueen_L_GeneralShale_GS_CapersIsland: 883,
  BrickQueen_L_GeneralShale_GS_CavalryGray: 334,
  BrickQueen_L_GeneralShale_GS_ClaytonFalls: 1094,
  BrickQueen_L_GeneralShale_GS_ColonyPointe: 1695,
  BrickQueen_L_GeneralShale_GS_Cortez: 1059,
  BrickQueen_L_GeneralShale_GS_CumberlandTudor: 1696,
  BrickQueen_L_GeneralShale_GS_Domino: 317,
  BrickQueen_L_GeneralShale_GS_EnglishPub: 1674,
  BrickQueen_L_GeneralShale_GS_Graymoor: 1080,
  BrickQueen_L_GeneralShale_GS_Graysburg: 1456,
  BrickQueen_L_GeneralShale_GS_HeritageTrail: 891,
  BrickQueen_L_GeneralShale_GS_Ironworks: 1675,
  BrickQueen_L_GeneralShale_GS_KeenelandElite: 582,
  BrickQueen_L_GeneralShale_GS_ManorHouseTudor: 583,
  BrickQueen_L_GeneralShale_GS_ModenaPaver: 1465,
  BrickQueen_L_GeneralShale_GS_MorningSmoke: 1457,
  BrickQueen_L_GeneralShale_GS_NewcastleGray: 644,
  BrickQueen_L_GeneralShale_GS_NolinRiver: 335,
  BrickQueen_L_GeneralShale_GS_OldEdisto: 650,
  BrickQueen_L_GeneralShale_GS_OldEnglishTutor: 1458,
  BrickQueen_L_GeneralShale_GS_Peppermill: 1676,
  BrickQueen_L_GeneralShale_GS_RedColonial: 1101,
  BrickQueen_L_GeneralShale_GS_ShadowGrey: 584,
  BrickQueen_L_GeneralShale_GS_SpanishMoss: 868,
  BrickQueen_L_GeneralShale_GS_StoneMountain: 884,
  BrickQueen_L_GeneralShale_GS_SwanCreek: 346,
  BrickQueen_L_GeneralShale_GS_Valor: 1122,
  BrickQueen_L_GeneralShale_GS_VintagePort: 637,
  BrickQueen_L_GeneralShale_GS_Winstar: 389,
  BrickQueen_L_GeneralShale_GS_Winterhaven: 1526,
  BrickQueen_L_GeneralShale_GS_Wynnewood: 638,
  BrickQueen_L_GlenGery_Americano: 1677,
  BrickQueen_L_GlenGery_AnthraciteSmooth: 1678,
  BrickQueen_L_GlenGery_AntiqueWhite: 231,
  BrickQueen_L_GlenGery_AspenWhite: 1679,
  BrickQueen_L_GlenGery_AztecWhite: 232,
  BrickQueen_L_GlenGery_BaxterBrownSmooth: 1680,
  BrickQueen_L_GlenGery_Birch: 233,
  BrickQueen_L_GlenGery_Casablanca: 234,
  BrickQueen_L_GlenGery_ClassicCreamSmooth: 1681,
  BrickQueen_L_GlenGery_RusticGrayWaterstruck: 1682,
  BrickQueen_L_GlenGery_WilliamsburgBradford: 235,
  BrickQueen_L_GlenGery_WilliamsburgCherryCreek: 236,
  BrickQueen_L_GlenGery_WilliamsburgHampton: 237,
  BrickQueen_L_Harristone_Charleston: 987,
  BrickQueen_L_Harristone_DoveGrey: 988,
  BrickQueen_L_Harristone_Midnight: 1554,
  BrickQueen_L_Harristone_WhiteSand: 989,
  BrickQueen_L_HenryBrick_HB_Avondale: 1555,
  BrickQueen_L_HenryBrick_HB_CypressPoint: 347,
  BrickQueen_L_Heritage_Ashwood: 1052,
  BrickQueen_L_Lusco_PearlRiver: 253,
  BrickQueen_L_Master_Chateau: 1840,
  BrickQueen_L_Master_PortEdwards: 1841,
  BrickQueen_L_Meridian_Alamo: 81,
  BrickQueen_L_Meridian_AlpineSelect: 82,
  BrickQueen_L_Meridian_Baytown: 83,
  BrickQueen_L_Meridian_Belhaven: 84,
  BrickQueen_L_Meridian_ChimneyMountain: 265,
  BrickQueen_L_Meridian_Dover: 85,
  BrickQueen_L_Meridian_FireOak: 1603,
  BrickQueen_L_Meridian_Laredo: 86,
  BrickQueen_L_Meridian_MtRushmore: 87,
  BrickQueen_L_Meridian_NorthHighland: 88,
  BrickQueen_L_Meridian_OldGuignard: 89,
  BrickQueen_L_Meridian_OldJackson: 90,
  BrickQueen_L_Meridian_PortHuron: 266,
  BrickQueen_L_Meridian_SaltPlains: 91,
  BrickQueen_L_Meridian_ShadowFalls: 92,
  BrickQueen_L_Meridian_Smithsonian: 93,
  BrickQueen_L_Meridian_StAndrews: 94,
  BrickQueen_L_Meridian_StLorain: 95,
  BrickQueen_L_Meridian_SummerAsh: 96,
  BrickQueen_L_Meridian_WhiteHillstone: 1604,
  BrickQueen_L_Meridian_WhiteRiverRock: 1605,
  BrickQueen_L_Paint_SW_SW_6246_NorthStar: 238,
  BrickQueen_L_Paint_SW_SW_7004_Snowbound: 308,
  BrickQueen_L_Paint_SW_SW_7068_GrizzleGray: 97,
  BrickQueen_L_Paint_SW_SW_9171_FeltedWool: 239,
  BrickQueen_L_Paint_SW_SW_9174_MothWing: 240,
  BrickQueen_L_PGH_Bark: 966,
  BrickQueen_L_PGH_CharacterPutty: 967,
  BrickQueen_L_PGH_CharacterRedRock: 968,
  BrickQueen_L_PrestigeStone_PS_Farmhouse: 1292,
  BrickQueen_L_ProVia_Boston: 1042,
  BrickQueen_L_ProVia_Cobblestone: 1043,
  BrickQueen_L_ProVia_Delaware: 1044,
  BrickQueen_L_ProVia_Midnight: 1045,
  BrickQueen_L_PVStone_Colonial: 1205,
  BrickQueen_L_PVStone_Neptune: 1206,
  BrickQueen_L_RedRiver_AlpineFog: 241,
  BrickQueen_L_RedRiver_Amarylis: 311,
  BrickQueen_L_RedRiver_BurlingtonAntique: 297,
  BrickQueen_L_RedRiver_Caprock: 298,
  BrickQueen_L_RedRiver_CrescentGrove: 242,
  BrickQueen_L_RedRiver_CypressSprings: 299,
  BrickQueen_L_RedRiver_FireOak: 243,
  BrickQueen_L_RedRiver_FlintRanch: 1345,
  BrickQueen_L_RedRiver_FoggyMorning: 812,
  BrickQueen_L_RedRiver_Glenwood: 244,
  BrickQueen_L_RedRiver_GlisteningSprings: 619,
  BrickQueen_L_RedRiver_Madrono: 1716,
  BrickQueen_L_RedRiver_Mayfield: 300,
  BrickQueen_L_RedRiver_OzarkSmoke: 1346,
  BrickQueen_L_RedRiver_Ridgemont: 301,
  BrickQueen_L_RedRiver_SaltPlains: 245,
  BrickQueen_L_RedRiver_ShadowFalls: 246,
  BrickQueen_L_RedRiver_ShelteredBluff: 247,
  BrickQueen_L_RedRiver_Silverado: 302,
  BrickQueen_L_RedRiver_SnowMist: 813,
  BrickQueen_L_RedRiver_SteelManor: 1842,
  BrickQueen_L_RedRiver_SummerAsh: 1843,
  BrickQueen_L_RedRiver_Tecomate: 248,
  BrickQueen_L_RedRiver_WellsValley: 254,
  BrickQueen_L_RedRiver_WhiteRiverRock: 814,
  BrickQueen_L_Ryder_AntiqueWhite: 1380,
  BrickQueen_L_Ryder_Casablanca: 1381,
  BrickQueen_L_Spaulding_Onslow: 1556,
  BrickQueen_L_Spaulding_YankeeHill: 1437,
  BrickQueen_L_TexasStone_DarkGrayLuxbrick: 1408,
  BrickQueen_L_TexasStone_OldTownLux: 1409,
  BrickQueen_L_Triangle_BessemerGray: 98,
  BrickQueen_L_Triangle_CapeFear: 1087,
  BrickQueen_L_Triangle_ChesapeakeGrey: 1185,
  BrickQueen_L_Triangle_DoverWhite: 377,
  BrickQueen_L_Triangle_EvelynBay: 99,
  BrickQueen_L_Triangle_FederalHill: 1175,
  BrickQueen_L_Triangle_FortMill: 869,
  BrickQueen_L_Triangle_JeffersonPark: 370,
  BrickQueen_L_Triangle_KnobHill: 1779,
  BrickQueen_L_Triangle_LibbyMill: 870,
  BrickQueen_L_Triangle_MountainBranchSelect: 100,
  BrickQueen_L_Triangle_Nantucket: 1108,
  BrickQueen_L_Triangle_Northampton: 141,
  BrickQueen_L_Triangle_Oakton: 1233,
  BrickQueen_L_Triangle_OldColony: 142,
  BrickQueen_L_Triangle_Oxford: 101,
  BrickQueen_L_Triangle_Porter: 620,
  BrickQueen_L_Triangle_Portsmouth: 1176,
  BrickQueen_L_Triangle_RiverStreet: 1177,
  BrickQueen_L_Triangle_SeelyTown: 371,
  BrickQueen_L_Triangle_ShadowRidge: 1619,
  BrickQueen_L_Triangle_SouthHampton: 102,
  BrickQueen_L_Triangle_Wilmington: 1178,
  BrickQueen_L_USBrick_Alamo: 1527,
  BrickQueen_L_USBrick_AspenChase: 1528,
  BrickQueen_L_USBrick_Belhaven: 1529,
  BrickQueen_L_USBrick_BelleMeade: 1530,
  BrickQueen_L_USBrick_Blackberry: 560,
  BrickQueen_L_USBrick_Laredo: 1780,
  BrickQueen_L_USBrick_Magnolia: 1293,
  BrickQueen_L_USBrick_Monaco: 1066,
  BrickQueen_L_USBrick_MtRushmore: 1531,
  BrickQueen_L_USBrick_NatchezTrace: 1294,
  BrickQueen_L_USBrick_Newcastle: 1532,
  BrickQueen_L_USBrick_NorthHighland: 1533,
  BrickQueen_L_USBrick_OldJackson: 1115,
  BrickQueen_L_USBrick_OldOverton: 1534,
  BrickQueen_L_USBrick_OldWaverly: 1234,
  BrickQueen_L_USBrick_OysterCove: 1295,
  BrickQueen_L_USBrick_ShadowStone: 1296,
  BrickQueen_L_USBrick_StLorain: 1535,
  BrickQueen_L_USBrick_TimberWood: 1297,
  BrickQueen_L_USBrick_Twilight: 1612,
  BrickQueen_L_USBrick_WeatheredWhite: 1717,
  TrimColorCodes: 0,
};
